webpackJsonp([1],{

/***/ "+iJg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0PbP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo_Spitzer_icone_braco.de30ec0.png";

/***/ }),

/***/ "1UXZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7YgM":
/***/ (function(module, exports) {

module.exports = {"name":"spa-schedule","version":"1.1.25","description":"Agendamento","author":"Alexandre Campagnaro <contato@spitzer.io>","private":true,"scripts":{"dev":"webpack-dev-server --inline --progress --config build/webpack.dev.conf.js","start":"npm run dev","build":"node build/build.js","unit":"jest test/unit/specs --coverage","e2e":"node test/e2e/runner.js","test":"npm run unit && npm run e2e","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs"},"dependencies":{"axios":"^0.24.0","cpf_cnpj":"^0.2.0","jsonwebtoken":"^8.2.1","localforage":"^1.5.6","moment":"^2.19.3","moment-range":"^3.1.0","qs":"^6.5.1","vee-validate":"^2.0.0","vue":"^2.6.14","vue-axios":"^3.2.5","vue-router":"^3.5.2","vue-slider-component":"^2.5.3","vue-the-mask":"^0.11.1","vuetify":"^0.17.1","vuex":"^3.0.1"},"devDependencies":{"@vue/devtools":"^1.1.0","autoprefixer":"^7.1.2","babel-core":"^6.22.1","babel-eslint":"^7.1.1","babel-jest":"^21.0.2","babel-loader":"^7.1.1","babel-plugin-transform-runtime":"^6.22.0","babel-preset-env":"^1.3.2","babel-preset-stage-2":"^6.22.0","babel-register":"^6.22.0","chalk":"^2.0.1","chromedriver":"^2.27.2","copy-webpack-plugin":"^4.0.1","cross-spawn":"^5.0.1","css-loader":"^0.28.7","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^3.0.0","eslint-loader":"^1.7.1","eslint-plugin-html":"^3.0.0","eslint-plugin-import":"^2.7.0","eslint-plugin-node":"^5.2.0","eslint-plugin-promise":"^3.4.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","extract-text-webpack-plugin":"^3.0.0","file-loader":"^1.1.4","friendly-errors-webpack-plugin":"^1.6.1","html-webpack-plugin":"^2.30.1","jest":"^21.2.0","nightwatch":"^0.9.12","node-notifier":"^5.1.2","optimize-css-assets-webpack-plugin":"^3.2.0","ora":"^1.2.0","portfinder":"^1.0.13","postcss-import":"^11.0.0","postcss-loader":"^2.0.8","rimraf":"^2.6.0","selenium-server":"^3.0.1","semver":"^5.3.0","shelljs":"^0.7.6","stylus":"^0.54.5","stylus-loader":"^3.0.1","url-loader":"^0.5.8","vue-jest":"^1.0.2","vue-loader":"^13.3.0","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.5.2","webpack":"^3.6.0","webpack-bundle-analyzer":"^2.9.0","webpack-dev-server":"^2.9.1","webpack-merge":"^4.1.0"},"jest":{"moduleFileExtensions":["js","json","vue"],"moduleNameMapper":{"^@/(.*)$":"<rootDir>/src/$1"},"transform":{"^.+\\.js$":"<rootDir>/node_modules/babel-jest",".*\\.(vue)$":"<rootDir>/node_modules/vue-jest"},"setupFiles":["<rootDir>/test/unit/setup"],"mapCoverage":true,"coverageDirectory":"<rootDir>/test/unit/coverage","collectCoverageFrom":["src/**/*.{js,vue}","!src/main.js","!src/router/index.js","!**/node_modules/**"]},"engines":{"node":">= 4.0.0","npm":">= 3.0.0"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ }),

/***/ "8mL5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo_Spitzer_icone.185d8e4.png";

/***/ }),

/***/ "AZBX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Adpk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/404-1.11ec77f.png";

/***/ }),

/***/ "E62A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HKey":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var actions_namespaceObject = {};
__webpack_require__.d(actions_namespaceObject, "toggleSidebar", function() { return actions_toggleSidebar; });
__webpack_require__.d(actions_namespaceObject, "toggleDevice", function() { return actions_toggleDevice; });
__webpack_require__.d(actions_namespaceObject, "setUser", function() { return actions_setUser; });
__webpack_require__.d(actions_namespaceObject, "setCustomer", function() { return actions_setCustomer; });
__webpack_require__.d(actions_namespaceObject, "setTokenRecoveryPassword", function() { return actions_setTokenRecoveryPassword; });
__webpack_require__.d(actions_namespaceObject, "expandMenu", function() { return actions_expandMenu; });
__webpack_require__.d(actions_namespaceObject, "switchEffect", function() { return actions_switchEffect; });
var getters_namespaceObject = {};
__webpack_require__.d(getters_namespaceObject, "app", function() { return app; });
__webpack_require__.d(getters_namespaceObject, "device", function() { return getters_device; });
__webpack_require__.d(getters_namespaceObject, "sidebar", function() { return sidebar; });
__webpack_require__.d(getters_namespaceObject, "effect", function() { return effect; });
__webpack_require__.d(getters_namespaceObject, "menuitems", function() { return menuitems; });
__webpack_require__.d(getters_namespaceObject, "auth", function() { return getters_auth; });
__webpack_require__.d(getters_namespaceObject, "customer", function() { return getters_customer; });
__webpack_require__.d(getters_namespaceObject, "tokenRecoveryPassword", function() { return tokenRecoveryPassword; });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/store/mutation-types.js
var TOGGLE_DEVICE = 'TOGGLE_DEVICE';

var TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

var EXPAND_MENU = 'EXPAND_MENU';

var SWITCH_EFFECT = 'SWITCH_EFFECT';

var AUTH = 'SET_USER';

var RECOVERY_PASSWORD = 'RECOVERY_PASSWORD';

var CUSTOMER = 'CUSTOMER';

var SCHEDULE = 'SCHEDULE';

var THEME = 'THEME';
// CONCATENATED MODULE: ./src/store/actions.js


var actions_toggleSidebar = function toggleSidebar(_ref, opened) {
  var commit = _ref.commit;
  return commit(TOGGLE_SIDEBAR, opened);
};

var actions_toggleDevice = function toggleDevice(_ref2, device) {
  var commit = _ref2.commit;
  return commit(TOGGLE_DEVICE, device);
};

var actions_setUser = function setUser(_ref3, user) {
  var commit = _ref3.commit;

  commit(AUTH, user);
};

var actions_setCustomer = function setCustomer(_ref4, customer) {
  var commit = _ref4.commit;

  commit(CUSTOMER, customer);
};

var actions_setTokenRecoveryPassword = function setTokenRecoveryPassword(_ref5, token) {
  var commit = _ref5.commit;

  commit(RECOVERY_PASSWORD, token);
};

var actions_expandMenu = function expandMenu(_ref6, menuItem) {
  var commit = _ref6.commit;

  if (menuItem) {
    menuItem.expanded = menuItem.expanded || false;
    commit(EXPAND_MENU, menuItem);
  }
};

var actions_switchEffect = function switchEffect(_ref7, effectItem) {
  var commit = _ref7.commit;

  if (effectItem) {
    commit(SWITCH_EFFECT, effectItem);
  }
};
// CONCATENATED MODULE: ./src/store/getters.js
// import { isEmpty } from 'lodash'

var app = function app(state) {
  return state.app;
};
var getters_device = function device(state) {
  return state.app.device;
};
var sidebar = function sidebar(state) {
  return state.app.sidebar;
};
var effect = function effect(state) {
  return state.app.effect;
};
var menuitems = function menuitems(state) {
  return state.menu.items;
};
var getters_auth = function auth(state) {
  return state.auth;
};
var getters_customer = function customer(state) {
  return state.customer;
};
var tokenRecoveryPassword = function tokenRecoveryPassword(state) {
  return state.recoveryPassword.token;
};


// EXTERNAL MODULE: ./package.json
var package_0 = __webpack_require__("7YgM");
var package_default = /*#__PURE__*/__webpack_require__.n(package_0);

// CONCATENATED MODULE: ./src/store/modules/app/state.js


/* harmony default export */ var state = ({
  theme: {
    color: 'indigo',
    colorHTML: '#3f51b5'
  },
  device: {
    isMobile: false,
    isTablet: false
  },
  pkg: {
    pkg: package_default.a
  }

});
// CONCATENATED MODULE: ./src/store/modules/app/actions.js

var setTheme = function setTheme(_ref, theme) {
  var commit = _ref.commit;

  commit('SET_THEME', theme);
};

var setDevice = function setDevice(_ref2, device) {
  var commit = _ref2.commit;

  commit('SET_DEVICE', device);
};
/* harmony default export */ var actions = ({
  setTheme: setTheme,
  setDevice: setDevice
});
// CONCATENATED MODULE: ./src/store/modules/app/getters.js

var getTheme = function getTheme(state) {
  return state.theme;
};
var getDevice = function getDevice(state) {
  return state.device;
};
var getPkg = function getPkg(state) {
  return state.pkg;
};

/* harmony default export */ var getters = ({
  getTheme: getTheme,
  getDevice: getDevice,
  getPkg: getPkg
});
// CONCATENATED MODULE: ./src/store/modules/app/mutations.js

var SET_THEME = function SET_THEME(state, payLoad) {
  var color = payLoad.color,
      colorHTML = payLoad.colorHTML;

  state.theme.color = color;
  state.theme.colorHTML = colorHTML;
};

var SET_DEVICE = function SET_DEVICE(state, payLoad) {
  var mobile = payLoad.mobile,
      tablet = payLoad.tablet;

  state.device.isMobile = mobile;
  state.device.isTablet = tablet;
};

/* harmony default export */ var mutations = ({
  SET_THEME: SET_THEME,
  SET_DEVICE: SET_DEVICE
});
// CONCATENATED MODULE: ./src/store/modules/app/index.js





/* harmony default export */ var modules_app = ({
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
});
// EXTERNAL MODULE: ./src/store/modules/menu/index.js
var menu = __webpack_require__("ZEli");
var menu_default = /*#__PURE__*/__webpack_require__.n(menu);

// CONCATENATED MODULE: ./src/store/modules/schedule/state.js

/* harmony default export */ var schedule_state = ({
  list: [],
  availableAppointments: {}
});
// CONCATENATED MODULE: ./src/store/modules/schedule/actions.js

var setList = function setList(_ref, schedule) {
  var commit = _ref.commit;

  commit('SET_LIST', schedule);
};

var setAvailableAppointments = function setAvailableAppointments(_ref2, schedule) {
  var commit = _ref2.commit;

  commit('SET_AVAILABLEAPPOINTMENTS', schedule);
};

/* harmony default export */ var schedule_actions = ({
  setList: setList,
  setAvailableAppointments: setAvailableAppointments
});
// CONCATENATED MODULE: ./src/store/modules/schedule/getters.js

var getList = function getList(state) {
  return state.list;
};
var getAvailableAppointments = function getAvailableAppointments(state) {
  return state.availableAppointments;
};

/* harmony default export */ var schedule_getters = ({
  getList: getList,
  getAvailableAppointments: getAvailableAppointments
});
// CONCATENATED MODULE: ./src/store/modules/schedule/mutations.js

var SET_LIST = function SET_LIST(state, schedule) {
  state.list = schedule;
};

var SET_AVAILABLEAPPOINTMENTS = function SET_AVAILABLEAPPOINTMENTS(state, schedule) {
  state.availableAppointments = schedule;
};

/* harmony default export */ var schedule_mutations = ({
  SET_LIST: SET_LIST,
  SET_AVAILABLEAPPOINTMENTS: SET_AVAILABLEAPPOINTMENTS
});
// CONCATENATED MODULE: ./src/store/modules/schedule/index.js





/* harmony default export */ var schedule = ({
  namespaced: true,
  state: schedule_state,
  actions: schedule_actions,
  mutations: schedule_mutations,
  getters: schedule_getters
});
// CONCATENATED MODULE: ./src/store/index.js


var _mutations;






// import * as mutations from 'mutations'





vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var store = new vuex_esm["a" /* default */].Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  actions: actions_namespaceObject,
  getters: getters_namespaceObject,
  modules: {
    app: modules_app,
    menu: menu_default.a,
    schedule: schedule
  },
  state: {
    customer: '',
    auth: {
      isLogged: false,
      token: '',
      user: {
        username: '',
        id: '',
        client: {},
        clientId: '',
        name: '',
        healthInsurance: null,
        code: '',
        numberMedicalRecord: null,
        profile: {}
      }
    },
    recoveryPassword: {
      token: ''
    }
  },
  mutations: (_mutations = {}, defineProperty_default()(_mutations, AUTH, function (store, obj) {
    store.auth = obj;
  }), defineProperty_default()(_mutations, CUSTOMER, function (store, obj) {
    store.customer = obj;
  }), defineProperty_default()(_mutations, RECOVERY_PASSWORD, function (store, obj) {
    store.recoveryPassword.token = obj;
  }), _mutations)
});

/* harmony default export */ var src_store = (store);
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/localforage/dist/localforage.js
var localforage = __webpack_require__("22C0");
var localforage_default = /*#__PURE__*/__webpack_require__.n(localforage);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Home.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Home = ({
  data: function data() {
    return {
      footerAbsolute: true,
      show: true,
      fav: true,
      menu: false,
      message: true,
      hints: true,
      drawer: null,
      lastFiveDays: {
        min: null,
        max: null
      },
      menuItems: [{ title: 'Perfil', to: '/patient/profile', action: 'perfil' }, { title: 'Sair', to: '/patient/login', action: 'sair' }],
      items: [{ icon: 'home', text: 'Inicio', href: 'home', router: true, to: '/' }, { icon: 'history', text: 'Histórico', href: 'customer', router: true, to: '/patient/history' }, { icon: 'contacts', text: 'Perfil', href: 'patientProfile', router: true, to: '/patient/profile' }, { icon: 'lock', text: 'Redefinir Senha', href: 'recoveryProfile', router: true, to: '/patient/recovery-password' }],
      itemsNotification: [{ header: '16/01/2017' }, { avatar: 'https://cdn1.iconfinder.com/data/icons/health-and-medical-glyps/128/8-512.png', title: 'Cadastro', subtitle: "<span class='grey--text text--darken-2'>Bem vindo</span> — Seu cadastro foi efetuado com sucesso" }, { divider: true, inset: true }, { avatar: 'https://cdn1.iconfinder.com/data/icons/health-and-medical-glyps/128/8-512.png', title: 'Agendamento <span class="grey--text text--lighten-1"></span>', subtitle: "<span class='grey--text text--darken-2'>Agendamento</span> — Agora você pode agendar sua consulta." }, { divider: true, inset: true }, { avatar: 'https://cdn1.iconfinder.com/data/icons/health-and-medical-glyps/128/8-512.png', title: 'Notícia', subtitle: "<span class='grey--text text--darken-2'>Àgua</span> — A água faz muito bem ao organismo, ela atua em todas as funções do corpo (circulação, digestão, excreção)." }]
    };
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setUser']), Object(vuex_esm["b" /* mapActions */])('schedule', ['setList', 'setAvailableAppointments']), {
    actionMenu: function actionMenu(value) {
      if (value === 'sair') {
        this.logout();
      } else if (value === 'perfil') {
        this.$router.push('/patient/profile');
      }
    },
    logout: function logout() {
      localforage_default.a.removeItem('token');
      localforage_default.a.removeItem('user');
      var auth = {
        isLogged: false,
        token: '',
        user: {
          username: null,
          id: '',
          client: '',
          name: '',
          healthInsurance: null,
          code: ''
        }
      };
      this.setList({});
      this.setUser(auth);
      this.$router.push('/patient/login');
    }
  }),
  props: {
    source: String
  },
  mounted: function mounted() {
    // this.$vuetify.theme.primary = '#00d1b2'
    // console.log(this.getTheme.color)
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    customer: 'customer',
    auth: 'auth'
  }), Object(vuex_esm["c" /* mapGetters */])('app', ['getTheme']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f02cfc38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.auth.isLogged)?_c('v-navigation-drawer',{attrs:{"fixed":"","clipped":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.items),function(item,i){return [(item.heading)?_c('v-layout',{key:i,attrs:{"row":"","align-center":""}},[_c('v-flex',{attrs:{"xs6":""}},[(item.heading)?_c('v-subheader',[_vm._v("\n              "+_vm._s(item.heading)+"\n            ")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs6":""}},[_c('a',{staticClass:"body-2 black--text",attrs:{"href":"#!"}},[_vm._v("EDIT")])])],1):(item.children)?_c('v-list-group',{attrs:{"no-action":""},model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}},[_c('v-list-tile',{attrs:{"slot":"item"},on:{"click":function($event){}},slot:"item"},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.model ? item.icon : item['icon-alt']))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                "+_vm._s(item.text)+"\n              ")])],1)],1),_vm._v(" "),_vm._l((item.children),function(child,i){return _c('v-list-tile',{key:i,on:{"click":function($event){}}},[(child.icon)?_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(child.icon))])],1):_vm._e(),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                "+_vm._s(child.text)+"\n              ")])],1)],1)})],2):_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_c('router-link',{attrs:{"to":item.to}},[_vm._v("\n                "+_vm._s(item.text)+"\n              ")])],1)],1)],1)]})],2)],1):_vm._e(),_vm._v(" "),(_vm.auth.isLogged)?_c('v-toolbar',{attrs:{"color":this.getTheme.color,"dark":"","app":"","clipped-left":"","fixed":""}},[_c('v-toolbar-title',{staticClass:"ml-0 pl-3",style:(_vm.$vuetify.breakpoint.smAndUp ? 'width: 300px; min-width: 250px' : 'min-width: 72px')},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('span',{staticClass:"hidden-xs-only"},[_vm._v("Agendamento")])],1),_vm._v(" "),_c('div',{staticClass:"d-flex align-center",staticStyle:{"margin-left":"auto"}},[(this.auth.isLogged)?_c('div',[_c('v-menu',{attrs:{"offset-x":"","close-on-content-click":false,"nudge-width":200},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","dark":""},nativeOn:{"click":function($event){_vm.show = !_vm.show}},slot:"activator"},[_c('v-badge',{attrs:{"color":"this.getTheme.color","left":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v("3")]),_vm._v(" "),_c('v-icon',[_vm._v("notifications")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-list',[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":__webpack_require__("8mL5"),"alt":"Sptizer.io"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.auth.user.name.toUpperCase()))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Spitzer.io")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{class:_vm.fav ? 'red--text' : '',attrs:{"icon":""},on:{"click":function($event){_vm.fav = !_vm.fav}}},[_c('v-icon',[_vm._v("favorite")])],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-switch',{attrs:{"color":this.getTheme.color},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Notificações")])],1)],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.itemsNotification),function(item){return [(item.header)?_c('v-subheader',{domProps:{"textContent":_vm._s(item.header)}}):(item.divider)?_c('v-divider',{attrs:{"inset":item.inset}}):_c('v-list-tile',{key:item.title,attrs:{"avatar":""},on:{"click":function($event){}}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":item.avatar}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(item.subtitle)}})],1)],1)]})],2),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.menu = false}}},[_vm._v("Sair")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","dark":""},slot:"activator"},[_c('v-avatar',{attrs:{"size":"32px","tile":""}},[_c('img',{attrs:{"src":__webpack_require__("0PbP"),"alt":"Sptizer.io"}})])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.menuItems),function(item){return _c('v-list-tile',{key:item.title},[_c('router-link',{attrs:{"to":item.to}},[_c('v-list-tile-title',{on:{"click":function($event){$event.preventDefault();return _vm.actionMenu(item.action)}}},[_vm._v(_vm._s(item.title))])],1)],1)}),1)],1)],1):_c('div',[_c('router-link',{attrs:{"to":"/login"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("exit_to_app")])],1)],1)],1)])],1):_vm._e(),_vm._v(" "),_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-container',{staticStyle:{"min-height":"0"},attrs:{"fluid":"","grid-list-lg":""}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Home = (esExports);
// CONCATENATED MODULE: ./src/components/Home.vue
function injectStyle (ssrContext) {
  __webpack_require__("OISo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Home,
  components_Home,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Home = (Component.exports);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./config/customersTheme.js
const customersTheme = {
  '5ce5e06d2a311a13c55505b9': {
    name: 'Stage',
    theme: 'pink darken-4',
    colorHTML: '#880E4F',
    logo: 'https://cdn.clinic.inf.br/public/images/new-clinic.png',
    cssClass: 'backgroud-logo-spitzer'
  },

  '5f03ac45ee42d49e97146c3f': {
    name: 'Stage',
    theme: 'pink darken-4',
    colorHTML: '#880E4F',
    logo: 'https://cdn.clinic.inf.br/public/images/new-clinic.png',
    cssClass: 'backgroud-logo-spitzer'
  },

  // '5a9ac06729b69d13c076cc41': {
  //   name: 'Online-IPO',
  //   theme: 'pink darken-4',
  //   colorHTML: '#880E4F',
  //   logo: 'https://cdn.clinic.inf.br/public/images/logo-ipo.png',
  //   cssClass: 'backgroud-logo-ipo'
  // },
  '5aa5af745757da74a00d9138': {
    name: 'Online-Altclin',
    theme: 'red darken-4',
    colorHTML: '#d32f2f',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-alticlin.png',
    cssClass: 'backgroud-logo-alticlin'
  },
  '5ab94676e9fb5d49ae9bc641': {
    name: 'Online-Iguacu',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-iguacu.png',
    cssClass: 'backgroud-logo-iguacu'
  },
  // '5ac6894e806793790864e9db': {
  //   name: 'Online-Ophtalmus',
  //   theme: 'indigo darken-2',
  //   colorHTML: '#303F9F',
  //   logo: 'https://cdn.clinic.inf.br/public/images/logo-ophtalmus.png',
  //   cssClass: 'backgroud-logo-ophtalmus'
  // },
  '5adf40811bfbf60c10d53d72': {
    name: 'Online-Barigui',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-barigui.png',
    cssClass: 'backgroud-logo-barigui'
  },
  // '5b0d63a420fbbb0f70e77c26': {
  //   name: 'Online-CliniDerma',
  //   theme: 'orange darken-3',
  //   colorHTML: '#EF6C00',
  //   logo: 'https://cdn.clinic.inf.br/public/images/logo-cliniderma.png',
  //   cssClass: 'backgroud-logo-cliniderma'
  // },
  '5b0d65f320fbbb0f70e77c27': {
    name: 'Online-Hosp-SaoLucas',
    theme: 'blue lighten-1',
    colorHTML: '#42a5f5',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-saolucas.png',
    cssClass: 'backgroud-logo-hosp-saolucas'
  },
  '5af4a0f420fbbb0f70e7743a': {
    name: 'Online-Clinica-Adel-Bark',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-adel-bark.png',
    cssClass: 'backgroud-logo-hosp-saolucas'
  },
  '5aa5ab0e7919573958da8833': {
    name: 'Online-Otorrinos-Curitiba',
    theme: 'brown lighten-4',
    colorHTML: '#D7CCC8',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-otorrinos.png',
    cssClass: 'backgroud-logo-otorrinos'
  },
  '5b3e227df84fc9467e0ef6de': {
    name: 'Online-Porto-seguro',
    theme: 'orange darken-3',
    colorHTML: '#EF6C00',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-porto-seguro.png',
    cssClass: 'backgroud-logo-porto-seguro'
  },
  '5bacec3633ab500ff7c96007': {
    name: 'Online-Oftalmoclinica-Curitiba',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-oftalmocuritiba.png',
    cssClass: 'backgroud-logo-oftalmoclinica-curitiba'
  },
  '5be1cede33ab500ff7c974ba': {
    name: 'Online-Alcides-Branco',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-alcidesbranco.png',
    cssClass: 'backgroud-logo-alcides-branco'
  },
  '5ac68816806793790864e9d5': {
    name: 'Online-Instituto-Crianca',
    theme: 'blue lighten-1',
    colorHTML: '#42a5f5',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-crianca.png',
    cssClass: 'backgroud-logo-instituto-crianca'
  },
  '5c9cb6fbaf1b077717153d74': {
    name: 'Online-Costa-Claro',
    theme: 'amber lighten-2',
    colorHTML: '#FFD54F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-costa-claro.png',
    cssClass: 'backgroud-logo-costa-claro'
  },
  // '5d137731c35f0e6e45ab549e': {
  //   name: 'Online-Inga-COI',
  //   theme: 'indigo darken-2',
  //   colorHTML: '#303F9F',
  //   logo: 'https://cdn.clinic.inf.br/public/images/logo-inga-coi.png',
  //   cssClass: 'backgroud-logo-inga-coi'
  // },
  '5d38a6c8bf9ff07fcd3c1fc6': {
    name: 'Online-Poli-Fazenda',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-poli-fazenda.png',
    cssClass: 'backgroud-logo-poli-fazenda'
  },
  '5d5aee56bf9ff07fcd3c2df9': {
    name: 'Online-Jardim-Americas',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-centro-medico-sjda.png',
    cssClass: 'backgroud-logo-poli-fazenda'
  },
  '5ca259b2af1b07771715409b': {
    name: 'Online-Pulmonar',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-pulmonar.webp',
    cssClass: 'backgroud-logo-poli-fazenda'
  },
  '5e382ee8f0ad900810aefb56': {
    name: 'Online-Ortoclinica',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://storage.googlv12.22.5eapis.com/spitzer-risc-logos/logo_otoclinica_editado.png',
    cssClass: 'backgroud-logo-poli-fazenda'
  },
  '5e503a56462560492f99a1e1': {
    name: 'Online-Cedac',
    theme: 'red darken-4',
    colorHTML: '#d32f2f',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-cedac.png',
    cssClass: 'backgroud-logo-poli-fazenda'
  },
  '5efa3ec74d34bf5a9865bbcf': {
    name: 'Online-Climm',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-climm.JPG',
    cssClass: 'backgroud-logo-poli-fazenda'
  },
  '5b6a011ede520c621a0bdb29': {
    name: 'Online-ARTRO',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-artro-white.svg',
    cssClass: 'backgroud-logo-artro'
  },
  '5e736368769e710930a3e597': {
    name: 'Online-SAKATO',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-sakata.png',
    cssClass: 'backgroud-logo-artro'
  },
  '5f50f33367657c4ccd58f847': {
    name: 'Online-IMOF',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-imof.png',
    cssClass: 'backgroud-logo-poli-fazenda'
  },
  '5f7db55feb97640d5d5e5236': {
    name: 'Online-ANDROLAB',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-androlab-new.png',
    cssClass: 'backgroud-logo-poli-fazenda'
  },
  '5edfe54ec2ded3227d18ff14': {
    name: 'Online-INC',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-inc.png',
    cssClass: 'backgroud-logo-poli-fazenda'
  },
  '5fd0fb55d788e61c704abb76': {
    name: 'Online-INC',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-uroclinica.png',
    cssClass: 'backgroud-logo-poli-fazenda'
  },
  '5fc4f0f2c5911e3f09ce250d': {
    name: 'Online-IPO-Dermato',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-ipo.png',
    cssClass: 'backgroud-logo-ipo'
  },
  '60073cd668d7f96a37455ff5': {
    name: 'Online-Cepelle',
    theme: 'pink darken-4',
    colorHTML: '#880E4F',
    logo: 'http://cepelle.com.br/wp-content/uploads/2020/04/thumbnail_logo.png',
    cssClass: 'backgroud-logo-ipo'
  },
  '6022c29bd01ce52fbc087204': {
    name: 'Online-Ballin',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-ballin.jpeg',
    cssClass: 'backgroud-logo-ipo'
  },
  '5c4f406a7fc6ce4155ace08e': {
    name: 'Online-Inccor',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-incor.JPG',
    cssClass: 'backgroud-logo-ipo'
  },
  '6040d7ead01ce52d19087870': {
    name: 'Online-CLINICA-JUK-BENKE-CLINICA-FAGUNDES',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-juk-benke.png',
    cssClass: 'backgroud-logo-ipo'
  },
  '5f72240fd168833f71c7a34d': {
    name: 'Online-Immef',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-immef.svg',
    cssClass: 'backgroud-logo-iguacu'
  },
  '5f19db3d6aabc95bc449cc4c': {
    name: 'CLINICA-DE-CONTI',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-conti.png',
    cssClass: 'backgroud-logo-iguacu'
  },
  '60885c7aabd9fc633734cf53': {
    name: 'UNION-CEMOC',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-union-cemoc.png',
    cssClass: 'backgroud-logo-iguacu'
  },
  '60c764fe9144fdac6a6bf5db': {
    name: 'SORAYA',
    theme: 'indigo darken-2',
    colorHTML: '#303F9F',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-soroya.png',
    cssClass: 'backgroud-logo-spitzer'
  },
  '6108456d772b6c1a983c87ad': {
    name: 'Online-Cleusa-canan',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-clinica-cleuza-canan.png',
    cssClass: 'backgroud-logo-iguacu'
  },
  '5ac68838806793790864e9d6': {
    name: 'Online-Ivisao',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-ivisao.png',
    cssClass: 'backgroud-logo-iguacu'
  },
  '61fbd6a32274318541502871': {
    name: 'COP - CLÍNICA DE OLHOS E PÁLPEBRAS JARDIM AMBIENTAL',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-poc-palpebras-e-olhos.jpg',
    cssClass: 'backgroud-logo-iguacu'
  },
  '6112799f18ba88250a32845f': {
    name: 'MEDSUL',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-medsul.png',
    cssClass: 'backgroud-logo-iguacu'
  },
  '627e912c197f9a3164daf043': {
    name: 'CLINICA SAO VICENTE',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-csv.png',
    cssClass: 'backgroud-logo-iguacu'
  },
  '628f7d2edd0fc258ba26d5e5': {
    name: 'INSTITUTO DO APARELHO DIGESTIVO',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-iad.png',
    cssClass: 'backgroud-logo-iguacu'
  },
  '5e381ef2f0ad900810aefb3c': {
    name: 'CLÍNICA HARMONIA',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-harmonia.png',
    cssClass: 'backgroud-logo-iguacu'
  },
  '620e934826d34466d05951d2': {
    name: 'STELLA MARIS',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-clinic.png',
    cssClass: 'backgroud-logo-iguacu'
  },
  '5e4ee35b462560492f99a162': {
    name: 'STAGE',
    theme: 'teal darken-3',
    colorHTML: '#00695C',
    logo: 'https://cdn.clinic.inf.br/public/images/logo-clinic.png',
    cssClass: 'backgroud-logo-iguacu'
  },
}

/* harmony default export */ var config_customersTheme = (customersTheme);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/auth/Login.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import { url } from '../../../config/api.link.connection'


/* harmony default export */ var Login = ({
  name: 'Login',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    customer: 'customer'
  }), Object(vuex_esm["c" /* mapGetters */])('app', ['getTheme', 'getPkg'])),
  mounted: function mounted() {
    this.$vuetify.theme.primary = this.getTheme.colorHTML; // this.getTheme.color
    this.loadHealthInsurance();
  },

  data: function data() {
    return {
      env: "https://api.spitzer.io",
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      usernameRules: [function (v) {
        return !!v || 'E-Mail obrigatório!';
      }],
      passwordRules: [function (v) {
        return !!v || 'Senha obrigatória!';
      }],
      valid: true,
      e1: true,
      auth: {
        isLogged: false,
        token: '',
        user: {
          username: '',
          password: '',
          id: '',
          client: '',
          name: ''
        }
      },
      checkbox: false
    };
  },
  methods: extends_default()({
    loadHealthInsurance: function loadHealthInsurance() {
      var _this = this;

      this.$http.get("https://api.spitzer.io" + '/schedule-online/health-insurance', {
        params: {
          customer: this.customer
        }
      }).then(function () {
        _this.valid = true;
      }).catch(function (err) {
        _this.snackbarConfig.snackbar = true;
        // this.snackbarConfig.color = 'alert'
        _this.snackbarConfig.text = 'Servidor da clinica não esta ativo!';
        _this.valid = false;
        console.log(err);
      });
    },
    changeCssColor: function changeCssColor() {
      var customerTheme = config_customersTheme[localStorage.getItem('riscSchedulePatientCustomer')];
      // console.log(customerTheme.cssClass)
      return customerTheme.cssClass;
    },
    changeLogo: function changeLogo() {
      var customerTheme = config_customersTheme[localStorage.getItem('riscSchedulePatientCustomer')];
      return customerTheme.logo;
    },
    changeColorHTML: function changeColorHTML() {
      var customerTheme = config_customersTheme[localStorage.getItem('riscSchedulePatientCustomer')];
      return customerTheme.colorHTML;
    }
  }, Object(vuex_esm["b" /* mapActions */])(['setUser']), {
    submit: function submit() {
      var _this2 = this;

      if (this.$refs.form.validate()) {
        axios_default.a.post("https://api.spitzer.io" + '/schedule-online/auth/patient/login', {
          username: this.auth.user.username,
          password: this.auth.user.password
        }, {
          params: {
            customer: this.customer
          }
        }).then(function (response) {
          // if (this.checkbox) {
          //   localStorage.setItem('token', response.data.result.token)
          // }
          var auth = {
            isLogged: true,
            token: response.data.result.token,
            user: {
              username: _this2.auth.user.username,
              id: response.data.result.user._id,
              customer: response.data.result.user.customer,
              name: response.data.result.user.name,
              healthInsurance: parseInt(response.data.result.user.healthInsurance),
              numberMedicalRecord: parseInt(response.data.result.user.numberMedicalRecord),
              profile: response.data.result.user.profile,
              // client: response.data.result.result[0].scheduleOnline.client[0],
              clientId: response.data.result.user._id
            }
          };
          _this2.setUser(auth);
          if (_this2.checkbox) {
            localforage_default.a.setItem('token', response.data.result.token).then(function (value) {
              // console.log(value)
            });
            localforage_default.a.setItem('user', auth).then(function (value) {
              // console.log(value)
            });
          }
          _this2.$router.push('/');
        }).catch(function (err) {
          if (err.response.data.message) {
            _this2.snackbarConfig.snackbar = true;
            _this2.snackbarConfig.text = err.response.data.message;
            return false;
          }
          if (err.response.data.errors) {
            if (err.response.data.errors.username) {
              _this2.snackbarConfig.snackbar = true;
              _this2.snackbarConfig.text = err.response.data.errors.username.msg;
              return false;
            }
            if (err.response.data.errors.password) {
              _this2.snackbarConfig.snackbar = true;
              _this2.snackbarConfig.text = err.response.data.errors.username.password.msg;
              return false;
            }
          }
          _this2.snackbarConfig.snackbar = true;
          _this2.snackbarConfig.text = err.response.data.result.error;
        });
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f13f455e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/Login.vue
var Login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":"","lg4":""}},[_c('v-card',[_c('v-card-media',{class:_vm.changeCssColor(),attrs:{"src":_vm.changeLogo(),"height":"200px","contain":""}}),_vm._v(" "),_c('div',{staticClass:"backgroud-logo logo"}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"action":"#","lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.submit()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit()}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":"E-Mail","rules":_vm.usernameRules,"required":""},model:{value:(_vm.auth.user.username),callback:function ($$v) {_vm.$set(_vm.auth.user, "username", $$v)},expression:"auth.user.username"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"input-10-1","label":"Entre com sua senha","hint":"Deve conter mais de 6 caracteres","min":"6","rules":_vm.passwordRules,"append-icon":_vm.e1 ? 'visibility_off' : 'visibility',"append-icon-cb":function () { return (_vm.e1 = !_vm.e1); },"type":_vm.e1 ? 'password' : 'text',"counter":""},model:{value:(_vm.auth.user.password),callback:function ($$v) {_vm.$set(_vm.auth.user, "password", $$v)},expression:"auth.user.password"}}),_vm._v(" "),_c('router-link',{attrs:{"to":"/patient/forget-password"}},[_c('p',{staticClass:"text-xs-right title"},[_vm._v("Esqueceu sua senha?")])]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","block":"","disabled":!_vm.valid},on:{"click":function($event){return _vm.submit()}}},[_vm._v("\n                Login\n              ")]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":"/patient/register"}},[_c('v-btn',{attrs:{"block":""}},[_vm._v("Cadastrar")])],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('div',[_c('p',[_vm._v("© 2017 - "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"http://www.spitzer.io"}},[_vm._v("Spitzer.io")]),_vm._v(" - Todos os direitos reservados")]),_vm._v(" "),_c('p',[_vm._v("Versão: "+_vm._s(_vm.getPkg.pkg.version))])])])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarConfig.timeout,"color":_vm.snackbarConfig.color,"multi-line":_vm.snackbarConfig.mode === 'multi-line',"vertical":_vm.snackbarConfig.mode === 'vertical'},model:{value:(_vm.snackbarConfig.snackbar),callback:function ($$v) {_vm.$set(_vm.snackbarConfig, "snackbar", $$v)},expression:"snackbarConfig.snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarConfig.text)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbarConfig.snackbar = false}}},[_vm._v("Fechar")])],1)],1)}
var Login_staticRenderFns = []
var Login_esExports = { render: Login_render, staticRenderFns: Login_staticRenderFns }
/* harmony default export */ var auth_Login = (Login_esExports);
// CONCATENATED MODULE: ./src/views/auth/Login.vue
function Login_injectStyle (ssrContext) {
  __webpack_require__("E62A")
}
var Login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Login___vue_template_functional__ = false
/* styles */
var Login___vue_styles__ = Login_injectStyle
/* scopeId */
var Login___vue_scopeId__ = "data-v-f13f455e"
/* moduleIdentifier (server only) */
var Login___vue_module_identifier__ = null
var Login_Component = Login_normalizeComponent(
  Login,
  auth_Login,
  Login___vue_template_functional__,
  Login___vue_styles__,
  Login___vue_scopeId__,
  Login___vue_module_identifier__
)

/* harmony default export */ var views_auth_Login = (Login_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//

// import { AppMain } from './components/layout/'



/* harmony default export */ var App = ({
  components: {
    Home: src_components_Home,
    VLogin: views_auth_Login
  },
  data: function data() {
    return {
      exibe: true,
      isMobile: false,
      isTablet: false
    };
  },
  mounted: function mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true });
    // this.$vuetify.theme.primary = '#4caf50'
    // console.log(this.$vuetify.theme.secondary)
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true });
    }
  },

  methods: {
    onResize: function onResize() {
      // this.isMobile = window.innerWidth < 600
      if (window.innerWidth < 600) {
        this.isMobile = true;
        this.isTablet = false;
      } else if (window.innerWidth > 600 && window.innerWidth < 960) {
        this.isMobile = false;
        this.isTablet = true;
      } else if (window.innerWidth > 960) {
        this.isTablet = false;
        this.isMobile = false;
      }
      src_store.dispatch('app/setDevice', { mobile: this.isMobile, tablet: this.isTablet }).then(function () {
        // console.log()
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c26467a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[(_vm.exibe === true)?_c('div',[_c('home')],1):_c('div',[_c('v-login')],1)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("HKey")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var core_js_promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(core_js_promise);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/customer/Customer.vue

//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Customer = ({
  name: 'Customer',
  data: function data() {
    return {
      error: null,
      customers: []
    };
  },
  mounted: function mounted() {
    // this.customer()
    this.loadingCustomers();
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setCustomer']), {
    loadingCustomers: function loadingCustomers() {
      var _this = this;

      this.$http.get("https://api.spitzer.io" + '/customers', {
        params: {
          customer: this.customer
        }
      }).then(function (results) {
        _this.customers = results.data.result;
        console.log(results.data.result);
      }).catch(function (err) {
        console.log(err);
      });
    },
    customer: function customer(_customer) {
      window.location = '/login?customer=' + _customer;
      // // window.location = '/login/' + customer
      this.setCustomer(_customer);
      localStorage.setItem('riscSchedulePatientCustomer', _customer);
      this.$router.push('/');
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fd7a774","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/customer/Customer.vue
var Customer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('span',[_vm._v("Raised Light Theme")]),_vm._v(" "),_c('v-card',{attrs:{"height":"185px","flat":"","color":"white"}},[_c('v-card-text',_vm._l((_vm.customers),function(item){return _c('div',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.customer(item._id)}}},[_vm._v(_vm._s(item.name))])],1)}),0)],1)],1)}
var Customer_staticRenderFns = []
var Customer_esExports = { render: Customer_render, staticRenderFns: Customer_staticRenderFns }
/* harmony default export */ var customer_Customer = (Customer_esExports);
// CONCATENATED MODULE: ./src/views/customer/Customer.vue
var Customer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Customer___vue_template_functional__ = false
/* styles */
var Customer___vue_styles__ = null
/* scopeId */
var Customer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Customer___vue_module_identifier__ = null
var Customer_Component = Customer_normalizeComponent(
  Customer,
  customer_Customer,
  Customer___vue_template_functional__,
  Customer___vue_styles__,
  Customer___vue_scopeId__,
  Customer___vue_module_identifier__
)

/* harmony default export */ var views_customer_Customer = (Customer_Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/index.js
var dist = __webpack_require__("GDE4");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Professionals.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var srcs = {
  1: 'https://app.kazah.com.br/img/newuser.png',
  2: 'https://app.kazah.com.br/img/newuser.png',
  3: 'https://app.kazah.com.br/img/newuser.png',
  4: 'https://app.kazah.com.br/img/newuser.png',
  5: 'https://app.kazah.com.br/img/newuser.png'
};
/* harmony default export */ var Professionals = ({
  name: 'Professionals',
  data: function data() {
    return {
      e11: [],
      people: [{ header: 'Otorrino' }, { name: 'Sandra Adams', group: 'Otorrino', avatar: srcs[1] }, { name: 'Ali Connors', group: 'Otorrino', avatar: srcs[2] }, { name: 'Trevor Hansen', group: 'Otorrino', avatar: srcs[3] }, { name: 'Tucker Smith', group: 'Otorrino', avatar: srcs[2] }, { divider: true }, { header: 'Cardiologista' }, { name: 'Britta Holt', group: 'Cardiologista', avatar: srcs[4] }, { name: 'Jane Smith ', group: 'Cardiologista', avatar: srcs[5] }, { name: 'John Smith', group: 'Cardiologista', avatar: srcs[1] }, { name: 'Sandra Williams', group: 'Cardiologista', avatar: srcs[3] }, { divider: true }, { header: 'Oftalmo' }, { name: 'Britta Holt1', group: 'Oftalmo', avatar: srcs[4] }, { name: 'Jane Smith1 ', group: 'Oftalmo', avatar: srcs[5] }, { name: 'John Smith1', group: 'Oftalmo', avatar: srcs[1] }, { name: 'Sandra Williams1', group: 'Oftalmo', avatar: srcs[3] }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3269e961","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Professionals.vue
var Professionals_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"label":"Profissional","items":_vm.people,"item-text":"name","item-value":"name","multiple":"","chips":"","max-height":"auto","autocomplete":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{key:JSON.stringify(data.item),staticClass:"chip--select-multi",attrs:{"close":"","selected":data.selected},on:{"input":function($event){return data.parent.selectItem(data.item)}}},[_c('v-avatar',[_c('img',{attrs:{"src":data.item.avatar}})]),_vm._v("\n                  "+_vm._s(data.item.name)+"\n                ")],1)]}},{key:"item",fn:function(data){return [(typeof data.item !== 'object')?[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item)}})]:[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":data.item.avatar}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(data.item.name)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(data.item.group)}})],1)]]}}]),model:{value:(_vm.e11),callback:function ($$v) {_vm.e11=$$v},expression:"e11"}})],1)}
var Professionals_staticRenderFns = []
var Professionals_esExports = { render: Professionals_render, staticRenderFns: Professionals_staticRenderFns }
/* harmony default export */ var components_Professionals = (Professionals_esExports);
// CONCATENATED MODULE: ./src/components/Professionals.vue
var Professionals_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Professionals___vue_template_functional__ = false
/* styles */
var Professionals___vue_styles__ = null
/* scopeId */
var Professionals___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Professionals___vue_module_identifier__ = null
var Professionals_Component = Professionals_normalizeComponent(
  Professionals,
  components_Professionals,
  Professionals___vue_template_functional__,
  Professionals___vue_styles__,
  Professionals___vue_scopeId__,
  Professionals___vue_module_identifier__
)

/* harmony default export */ var src_components_Professionals = (Professionals_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/schedule/Schedule.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import { url } from '../../../config/api.link.connection'
moment_default.a.locale('pt-br');

/* harmony default export */ var Schedule = ({
  name: 'Schedule',
  components: {
    VProfessionals: src_components_Professionals,
    vueSlider: dist_default.a
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    customer: 'customer',
    auth: 'auth'
  }), Object(vuex_esm["c" /* mapGetters */])('schedule', ['getList', 'getAvailableAppointments']), Object(vuex_esm["c" /* mapGetters */])('app', ['getTheme', 'getDevice'])),
  watch: {
    specialist: function specialist(newVal, oldVal) {
      if (newVal !== undefined) {
        this.loadingProfessionals();
      }
    },
    professional: function professional(newVal, oldVal) {},

    // Carrega quando muda a tag HTML ??
    // select (newVal, oldVal) {
    //   this.loadingDates(newVal)
    // },
    date: function date(newVal, oldVal) {
      var _this = this;

      this.countIndexArray = 0;
      this.dateExtension = moment_default()(newVal).format('LL');
      var arrayDates = lodash_default.a.filter(this.getList, function (o) {
        return moment_default()(o.tbData, 'DD/MM/YYYY').format('YYYY-MM-DD') === newVal;
      });
      this.arrayDatesAll = arrayDates;
      var arrayDoctors = [];

      lodash_default.a.filter(arrayDates, function (o) {
        _this.professionals.map(function (item) {
          if (o.tbMedico === item.id) {
            arrayDoctors.push({ id: o.tbMedico, name: item.name, date: o.tbData, hour: o.tbHora.substr(0, 5) });
          }
        });
      });

      var nameDoctors = arrayDoctors.map(function (item) {
        return {
          id: item.id,
          name: item.name
        };
      });
      var uniqueArray = lodash_default.a.uniqBy(nameDoctors, function (o) {
        return o.name;
      });
      this.nameDoctorsFilters = uniqueArray;
      this.availableAppointments(this.arrayDatesAll, uniqueArray[0].id);
    },
    healthInsurance: function healthInsurance(newVal, oldVal) {
      this.loadingSpecialist();
      this.loadingProfessionals();
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])('schedule', ['setList', 'setAvailableAppointments']), {
    scheduleAppointment: function scheduleAppointment() {
      var _this2 = this;

      this.getAvailableAppointments.obs = this.obs ? 'Obs. Paciente: ' + this.obs : null;
      this.$http.post("https://api.spitzer.io" + '/schedule-online/schedule-sync/schedule-appointment', {
        data: this.getAvailableAppointments
      }, {
        params: {
          customer: this.customer,
          token: this.auth.token
        }
      }).then(function (response) {
        _this2.$router.push('/patient/history');
      }).catch(function (err) {
        if (_this2.data === undefined || _this2.data === {}) {
          return console.error('Falha na comunicação com o servidor');
        }
        console.error(err);
        _this2.snackbarConfig.snackbar = true;
        _this2.snackbarConfig.text = err.response.data.result.error;
      });
    },
    getHour: function getHour(hour) {
      hour.hour = hour.tbHora.substr(0, 5);
      hour.tbNomeMedico = this.nameDoctorsFilters[this.countIndexArray].name;
      hour.idUser = this.auth.user.id;
      hour.client_email = this.auth.user.username;
      hour.client_name = this.auth.user.name;
      hour.health_insurance = this.healthInsurance; // this.auth.user.healthInsurance
      hour.numberMedicalRecord = this.auth.user.numberMedicalRecord;
      hour.client_phone_number = this.auth.user.profile.phone;
      hour.client_mobile_number = this.auth.user.profile.mobile;
      this.setAvailableAppointments(hour);
    },
    availableAppointments: function availableAppointments(arrayDates, doctor) {
      var arrayDoctorsAll = lodash_default.a.filter(arrayDates, function (o) {
        return o.tbMedico === doctor;
      });
      this.availableAppointment = arrayDoctorsAll;
    },
    addDoctor: function addDoctor() {
      if (this.countIndexArray + 1 < this.nameDoctorsFilters.length) {
        this.countIndexArray++;
        this.availableAppointments(this.arrayDatesAll, this.nameDoctorsFilters[this.countIndexArray].id);
      }
    },
    remDoctor: function remDoctor() {
      if (this.countIndexArray > 0) {
        this.countIndexArray--;
        this.availableAppointments(this.arrayDatesAll, this.nameDoctorsFilters[this.countIndexArray].id);
      }
    },
    unique: function unique(value, index, self) {
      return self.indexOf(value) === index;
    },
    loadHealthInsurance: function loadHealthInsurance() {
      var _this3 = this;

      this.$http.get("https://api.spitzer.io" + '/schedule-online/health-insurance', {
        params: {
          customer: this.customer
        }
      }).then(function (healthInsurance) {
        _this3.healthInsurances = healthInsurance.data.result;
        _this3.healthInsurance = _this3.auth.user.healthInsurance;
      }).catch(function (err) {
        console.error(err);
      });
    },
    loadingSpecialist: function loadingSpecialist() {
      var _this4 = this;

      this.$http.get("https://api.spitzer.io" + '/doctors/specialist/', {
        params: {
          customer: this.customer,
          healthInsurance: this.healthInsurance || this.auth.user.healthInsurance,
          birthDay: null || this.auth.user.profile.birthDay
        }
      }).then(function (specialist) {
        if (specialist.data.result === undefined || specialist.data.result === null) {
          _this4.specialists = [];
        } else {
          _this4.specialists = specialist.data.result;
          /** Codigo abaixo colocado após pedido da iguaçu - 05/04/2018 */
          if (specialist.data.result.length === 1) {
            var uniqueSpecialist = specialist.data.result.map(function (item) {
              return item.id;
            });
            _this4.specialist = uniqueSpecialist[0];
          } else {
            _this4.specialist = null;
          }
          /** ********************************************************** */
        }
      }).catch(function (err) {
        console.error(err);
      });
    },
    loadingProfessionals: function loadingProfessionals() {
      var _this5 = this;

      this.$http.get("https://api.spitzer.io" + '/doctors/', {
        params: {
          customer: this.customer,
          healthInsurance: this.healthInsurance || this.auth.user.healthInsurance,
          specialist: this.specialist,
          birthDay: null || this.auth.user.profile.birthDay
        }
      }).then(function (professionals) {
        if (professionals.data.result === undefined || professionals.data.result === null) {
          _this5.professionals = [];
        } else {
          _this5.professionals = professionals.data.result;
          _this5.professional = [];
          _this5.setList({});
          _this5.allowedDates = [];

          // this.nameDoctorsFilters = null
          // this.availableAppointment = []
        }
        // this.loadingDates()
      }).catch(function (err) {
        console.error(err);
      });
    },
    loadingBilling: function loadingBilling() {
      var _this6 = this;

      this.$http.get("https://api.spitzer.io" + '/schedule-online/billing', {
        params: {
          customer: this.customer,
          record: this.auth.user.numberMedicalRecord
        }
      }).then(function (result) {
        if (result.data.result.length > 0) {
          _this6.dialogSchedule = true;
        }
        _this6.items = result.data.result.map(function (item) {
          item.divider = true;
          item.inset = true;
          item.header = 'Você teve um faturamento nos ultimos 30 dias';
          return item;
        });
        _this6.items.title = 'Você teve um faturamento nos ultimos 30 dias';
      }).catch(function (err) {
        console.error(err);
      });
    },
    loadingSchedule: function loadingSchedule() {
      var _this7 = this;

      this.$http.get("https://api.spitzer.io" + '/schedule-online/schedule-sync/scheduled-appointments', {
        params: {
          customer: this.customer,
          record: this.auth.user.numberMedicalRecord
        }
      }).then(function (result) {
        if (result.data.results.results.length > 0) {
          _this7.dialogSchedule = true;
        }
        _this7.items = result.data.results.results.map(function (item) {
          item.divider = true;
          item.inset = true;
          item.header = 'Você possui agendamentos nos próximos 30 dias';
          return item;
        });
      }).catch(function (err) {
        console.error(err);
      });
    },
    clearloadingData: function clearloadingData() {
      this.allowedDates = [];
      this.availableAppointment = [];
    },
    loadingData: function loadingData() {
      var _this8 = this;

      if (!this.specialist) {
        this.snackbarConfig.snackbar = true;
        this.snackbarConfig.color = 'warning';
        this.snackbarConfig.text = 'Informe uma especialidade!';
        return false;
      }

      var qs = __webpack_require__("mw3O");
      // const firstDay = moment().format('MM-DD-YYYY')
      // const lastFifteenDays = moment().add(this.period.value || 7, 'day').format('MM-DD-YYYY')
      this.loadingOk = false;
      this.nameDoctorsFilters = null;
      this.allowedDates = [];
      this.availableAppointment = [];

      this.$http.get("https://api.spitzer.io" + '/schedule-online/schedule-sync/available-appointments', {
        params: {
          healthInsurance: this.healthInsurance,
          specialist: this.specialist,
          crm: this.professional,
          customer: this.customer,
          initial_datetime: moment_default()().format('MM-DD-YYYY'),
          end_datetime: moment_default()().add(this.period.value || 7, 'day').format('MM-DD-YYYY'),
          birthDay: this.auth.user.profile.birthDay
        },
        'paramsSerializer': function paramsSerializer(params) {
          return qs.stringify(params, { arrayFormat: 'repeat' });
        }
      }).then(function (response) {
        var obj = response.data.parameters;
        _this8.setList(obj);
        var item = obj.map(function (item) {
          return moment_default()(item.tbData, 'DD/MM/YYYY').format('YYYY-MM-DD');
        });
        var uniqueArray = item.filter(_this8.unique);
        _this8.allowedDates = uniqueArray;
        _this8.loadingOk = true;
      }).catch(function (err) {
        console.error(err);
      });
    }
  }),
  data: function data() {
    return {
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      period: {
        value: 3,
        interval: 3,
        min: 3,
        max: 30,
        width: '97%',
        tooltip: 'hover',
        disabled: false,
        piecewise: true,
        piecewiseLabel: true,
        bgStyle: {
          'backgroundColor': '#fff',
          'boxShadow': 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)'
        },
        tooltipStyle: {
          'backgroundColor': '#666',
          'borderColor': '#666'
        },
        processStyle: {
          'backgroundColor': '#999'
        }
      },
      dialog: false,
      dialogSchedule: false,
      arrayDatesAll: null,
      nameDoctorsFilters: null,
      countIndexArray: 0,
      doctors: [],
      healthInsurances: [],
      specialists: [],
      professionals: [],
      doctor: null,
      healthInsurance: null,
      specialist: null,
      professional: null,
      date: null,
      dateExtension: '',
      allowedDates: [],
      lastFiveDays: {
        min: null,
        max: null
      },
      loadingOk: true,
      availableAppointment: [],
      items: [],
      obs: null
    };
  },
  props: {
    source: String
  },
  mounted: function mounted() {
    this.allowedDates = [];
    this.loadHealthInsurance();
    this.loadingSpecialist();
    // this.loadingBilling()
    if (this.customer === '5b0d63a420fbbb0f70e77c26' || this.customer === '5d137731c35f0e6e45ab549e' || this.customer === '5e503a56462560492f99a1e1') {
      this.loadingSchedule();
      this.loadingBilling();
      this.period.max = 21;
    } else {
      this.period.max = this.period.max;
    }
    // const date = new Date()
    // const d = new Date()
    // d.setDate(date.getDate() - 5)
    // this.lastFiveDays.min = d.toISOString().substr(0, 10)
    // this.lastFiveDays.max = date.toISOString().substr(0, 10)
    // console.log(d.toISOString().substr(0, 10))
    // this.allowedDates = this.everyOtherDay
    // this.allowedDates = ["2017-12-26", "2017-12-04"]
    // console.log(this.allowedDates)
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61b7c311","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/schedule/Schedule.vue
var Schedule_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-progress-linear',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingOk === false),expression:"loadingOk === false"}],attrs:{"indeterminate":true}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('div',{staticClass:"text-xs-center",staticStyle:{"height":"30px","position":"relative","margin-top":"30px"}},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(this.allowedDates.length > 0),expression:"this.allowedDates.length > 0"}],attrs:{"disabled":_vm.loadingOk === false,"round":"","color":this.getTheme.color,"dark":_vm.loadingOk === true},on:{"click":function($event){return _vm.clearloadingData()}}},[_c('v-icon',[_vm._v("search")]),_vm._v(" refazer  busca\n        ")],1),_vm._v(" "),(_vm.getDevice.isMobile)?_c('v-chip',{directives:[{name:"show",rawName:"v-show",value:(this.allowedDates.length > 0),expression:"this.allowedDates.length > 0"}],staticClass:"ma-2",attrs:{"dark":"","color":this.getTheme.color,"text-color":"white"}},[_c('v-avatar',{attrs:{"left":""}},[_c('v-icon',[_vm._v("save_alt")])],1),_vm._v("\n          Role para baixo\n        ")],1):_vm._e()],1),_vm._v(" "),_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(this.allowedDates.length === 0),expression:"this.allowedDates.length === 0"}],attrs:{"div":""}},[_c('v-card-text',[_c('v-select',{attrs:{"item-text":"name","item-value":"id","label":"Convênio","items":_vm.healthInsurances,"rules":[function (v) { return !!v || 'Você deve informar o convênio!'; }],"required":"","disabled":this.customer === '5ab94676e9fb5d49ae9bc641'},model:{value:(_vm.healthInsurance),callback:function ($$v) {_vm.healthInsurance=$$v},expression:"healthInsurance"}}),_vm._v(" "),_c('v-select',{attrs:{"item-text":"name","item-value":"id","label":"Especialidade","items":_vm.specialists,"rules":[function (v) { return !!v || 'Você deve informar a especialidade!'; }],"required":"","disabled":!this.healthInsurances.length},model:{value:(_vm.specialist),callback:function ($$v) {_vm.specialist=$$v},expression:"specialist"}}),_vm._v(" "),_c('v-select',{attrs:{"item-text":"name","item-value":"id","label":"Selecione um ou mais profissionais de sua preferência ou deixe em branco para todos","multiple":"","chips":"","items":_vm.professionals,"disabled":!this.specialist},model:{value:(_vm.professional),callback:function ($$v) {_vm.professional=$$v},expression:"professional"}})],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"30px","position":"relative"}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),(this.allowedDates.length === 0)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-icon',[_vm._v("event")]),_vm._v(" "),_c('span',[_vm._v("Período de dias para sua consulta")]),_vm._v(" "),_c('vue-slider',_vm._b({staticClass:"vue-slider",model:{value:(_vm.period.value),callback:function ($$v) {_vm.$set(_vm.period, "value", $$v)},expression:"period.value"}},'vue-slider',_vm.period,false))],1):_vm._e(),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(this.allowedDates.length === 0),expression:"this.allowedDates.length === 0"}]},[_c('div',{staticClass:"text-xs-center",staticStyle:{"height":"30px","position":"relative","margin-top":"30px"}},[_c('v-btn',{attrs:{"disabled":_vm.loadingOk === false,"round":"","color":this.getTheme.color,"dark":_vm.loadingOk === true},on:{"click":function($event){return _vm.loadingData()}}},[_c('v-icon',[_vm._v("search")]),_vm._v(" Buscar Horários\n        ")],1)],1)]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('v-flex',[((this.allowedDates.length) > 0)?_c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-card',[_c('v-card-text',[_c('v-date-picker',{staticClass:"mt-0",attrs:{"locale":"pt-br","allowed-dates":_vm.allowedDates,"landscape":!_vm.getDevice.isMobile,"color":this.getTheme.color,"full-width":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-card',[_c('v-card-actions',[_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[(_vm.nameDoctorsFilters)?_c('div',[_c('v-card',{attrs:{"color":"grey lighten-2"}},[_c('v-card-text',[_c('h3',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.nameDoctorsFilters[_vm.countIndexArray].name))])])],1),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-top":"-50px","margin-right":"13px"},attrs:{"absolute":"","dark":"","small":"","fab":"","right":"","color":this.getTheme.color},on:{"click":function($event){return _vm.addDoctor()}}},[_c('v-icon',[_vm._v("keyboard_arrow_right")])],1),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-top":"-50px","margin-left":"11px"},attrs:{"absolute":"","dark":"","small":"","fab":"","left":"","color":this.getTheme.color},on:{"click":function($event){return _vm.remDoctor()}}},[_c('v-icon',[_vm._v("keyboard_arrow_left")])],1)],1):_c('div',[_c('v-card',[_c('v-card-media',{staticClass:"white--text",attrs:{"height":"170px","src":"https://storage.googleapis.com/spitzer-risc-logos/agendamento.jpg"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}})],1)],1)],1),_vm._v(" "),_c('v-card-title',[_c('div',[_c('span',{staticClass:"blue-grey--text"},[_vm._v("Clique nas datas,")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"blue-grey--text"},[_vm._v("para informar os horários disponiveis")])])]),_vm._v(" "),_c('v-card-actions')],1)],1)])],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((this.availableAppointment),function(o){return _c('div',[_c('v-chip',{attrs:{"color":"light-blue lighten-1","text-color":"white"},on:{"click":function($event){return _vm.getHour(o)}},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_vm._v(_vm._s(o.tbHora.substr(0, 5)))])],1)}),0)],1)],1)],1)],1)],1):_vm._e()]),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-media',{staticClass:"white--text",attrs:{"height":"200px","src":"https://storage.googleapis.com/spitzer-risc-logos/agendamento.jpg"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}})],1)],1)],1),_vm._v(" "),_c('v-card-title',[_c('div',{staticStyle:{"width":"100%"}},[_c('span',{staticClass:"blue-grey--text headline"},[_vm._v("Sua consulta será com")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"blue-grey--text subheading"},[_c('b',[_vm._v(_vm._s(_vm.getAvailableAppointments.tbNomeMedico)+",")])]),_c('br'),_vm._v(" "),_c('span',{staticClass:"blue-grey--text subheading"},[_vm._v("no dia "),_c('b',[_vm._v(_vm._s(_vm.getAvailableAppointments.tbData))]),_vm._v(", às "),_c('b',[_vm._v(_vm._s(_vm.getAvailableAppointments.hour))]),_vm._v(" horas.")]),_vm._v(" "),_c('v-text-field',{staticStyle:{},attrs:{"item-text":"obs","item-value":"obs","items":_vm.obs,"label":"Observação","full-width":"","counter":"35","maxlength":"35","Observação":""},model:{value:(_vm.obs),callback:function ($$v) {_vm.obs=$$v},expression:"obs"}},[_vm._v(_vm._s(_vm.getAvailableAppointments.obs)+"\n              ")])],1)]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","block":""},on:{"click":function($event){return _vm.scheduleAppointment()}},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n            Agendar\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"secondary"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cancelar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"600"},model:{value:(_vm.dialogSchedule),callback:function ($$v) {_vm.dialogSchedule=$$v},expression:"dialogSchedule"}},[_c('v-card',[_c('v-card-media',{staticClass:"white--text",attrs:{"height":"200px","src":"https://storage.googleapis.com/spitzer-risc-logos/agendamento.jpg"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}})],1)],1)],1),_vm._v(" "),_c('v-card-title',[_c('div',[_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.items),function(item){return [(_vm.items.title)?_c('v-subheader',{key:item.id,domProps:{"textContent":_vm._s(_vm.items.title)}}):(item.divider)?_c('v-divider',{key:item.id,attrs:{"inset":item.inset}}):_vm._e(),_vm._v(" "),_c('v-list-tile',{key:item.hour_schedule,attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("event")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.doctor)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(item.date_schedule)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(item.hour_schedule)}})],1)],1)]})],2)],1)]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","block":""},on:{"click":function($event){}}},[_vm._v("\n            FAVOR ENTRAR EM CONTATO\n          ")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/patient/history"}},[_c('v-btn',{attrs:{"flat":"","color":"secondary"},nativeOn:{"click":function($event){_vm.dialogSchedule = false}}},[_vm._v("Cancelar agendamentos online")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarConfig.timeout,"color":_vm.snackbarConfig.color,"multi-line":_vm.snackbarConfig.mode === 'multi-line',"vertical":_vm.snackbarConfig.mode === 'vertical'},model:{value:(_vm.snackbarConfig.snackbar),callback:function ($$v) {_vm.$set(_vm.snackbarConfig, "snackbar", $$v)},expression:"snackbarConfig.snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarConfig.text)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbarConfig.snackbar = false}}},[_vm._v("Fechar")])],1)],1)}
var Schedule_staticRenderFns = []
var Schedule_esExports = { render: Schedule_render, staticRenderFns: Schedule_staticRenderFns }
/* harmony default export */ var schedule_Schedule = (Schedule_esExports);
// CONCATENATED MODULE: ./src/views/schedule/Schedule.vue
function Schedule_injectStyle (ssrContext) {
  __webpack_require__("+iJg")
}
var Schedule_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Schedule___vue_template_functional__ = false
/* styles */
var Schedule___vue_styles__ = Schedule_injectStyle
/* scopeId */
var Schedule___vue_scopeId__ = "data-v-61b7c311"
/* moduleIdentifier (server only) */
var Schedule___vue_module_identifier__ = null
var Schedule_Component = Schedule_normalizeComponent(
  Schedule,
  schedule_Schedule,
  Schedule___vue_template_functional__,
  Schedule___vue_styles__,
  Schedule___vue_scopeId__,
  Schedule___vue_module_identifier__
)

/* harmony default export */ var views_schedule_Schedule = (Schedule_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/cpf_cnpj/index.js
var cpf_cnpj = __webpack_require__("NW1g");
var cpf_cnpj_default = /*#__PURE__*/__webpack_require__.n(cpf_cnpj);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/auth/Register.vue



var Register__this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import { setTimeout } from 'timers'

/* harmony default export */ var Register = ({
  name: 'Register',
  computed: extends_default()({
    progress: function progress() {
      return Math.min(100, this.auth.password.length * 10);
    },
    color: function color() {
      return ['error', 'warning', 'success'][Math.floor(this.progress / 40)];
    }
  }, Object(vuex_esm["c" /* mapGetters */])({
    customer: 'customer'
  }), Object(vuex_esm["c" /* mapGetters */])('app', ['getTheme'])),
  data: function data() {
    return {
      dialogCancel: false,
      bodyData: false,
      birthday: {
        dateFormatted: null,
        menu: false
      },
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de comunicação com o servidor'
      },
      nameRules: [function (v) {
        return !!v || 'Nome obrigatório!';
      }, function (v) {
        return v.length <= 40 || 'Limite de 40 caracteres';
      }],
      passwordRules: [function (v) {
        return !!v || 'Senha obrigatória!';
      }, function (v) {
        return v.length <= 20 || 'Limite de 20 caracteres';
      }],
      exists: false,
      e1: 0,
      p1: true,
      custom: true,
      healthInsurances: [],
      valid: true,
      auth: {
        name: '',
        username: '',
        password: '',
        passwordConfirm: '',
        enabled: true,
        customer: Register__this.customer,
        customerName: '',
        type: 'Owner',
        cpf: '',
        birthDay: '',
        healthInsurance: '',
        phone: '',
        mobile: '',
        gender: 'M'
      },
      checkbox: false
    };
  },
  mounted: function mounted() {
    // console.log(this.$validator)
    this.loadHealthInsurance();
    // console.log(this.auth.birthDay.substring(0, 2) + '-' + this.auth.birthDay.substring(2, 4) + '-' + this.auth.birthDay.substring(4, 8))
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setUser']), {
    changeCssColor: function changeCssColor() {
      var customerTheme = config_customersTheme[localStorage.getItem('riscSchedulePatientCustomer')];
      // console.log(customerTheme.cssClass)
      return customerTheme.cssClass;
    },
    changeLogo: function changeLogo() {
      var customerTheme = config_customersTheme[localStorage.getItem('riscSchedulePatientCustomer')];
      return customerTheme.logo;
    },
    searchEmail: function searchEmail() {
      var _this2 = this;

      console.log(this.customer);
      this.$http.get("https://api.spitzer.io" + '/schedule-online/auth/patient/search-user', {
        params: {
          customer: this.customer,
          username: this.auth.username
        }
      }).then(function (emailUser) {
        _this2.dialogCancel = true;
        /** Verifica se já existe cadastro neste cliente */
        // const customer = emailUser.data.result[0].scheduleOnline.client.map(item => item.customer)
        // const exists = customer.filter(item => item === this.customer)
        // console.log(exists)
        // if (exists) {
        //   this.snackbarConfig.snackbar = true
        //   this.snackbarConfig.color = 'info'
        //   this.snackbarConfig.text = 'Você já possui cadastro!'
        //   setTimeout(() => {
        //     this.$router.push('/patient/login')
        //   }, 3000)
        // }
        /** *************************************** */

        // this.snackbarConfig.snackbar = true
        // this.snackbarConfig.color = 'info'
        // this.snackbarConfig.text = 'Você já possui cadastro na nossa base de dados! Digite sua senha já cadastrada'

        _this2.bodyData = true;
        _this2.auth = {
          username: _this2.auth.username,
          name: emailUser.data.result[0].name,
          password: '',
          enabled: true,
          passwordConfirm: '',
          customer: _this2.customer,
          customerName: '',
          type: 'Owner',
          cpf: emailUser.data.result[0].profile.cpf,
          birthDay: moment_default()(emailUser.data.result[0].profile.birthDay, 'MM/DD/YYYY').format('DD/MM/YYYY'),
          healthInsurance: '',
          phone: emailUser.data.result[0].profile.phone,
          mobile: emailUser.data.result[0].profile.mobile,
          gender: emailUser.data.result[0].profile.gender
          // this.$refs.healthInsurance.focus()
        };
      }).catch(function (err) {
        console.log(err);
      });
    },
    loadHealthInsurance: function loadHealthInsurance() {
      var _this3 = this;

      this.$http.get("https://api.spitzer.io" + '/schedule-online/health-insurance', {
        params: {
          customer: this.customer
        }
      }).then(function (healthInsurance) {
        _this3.healthInsurances = healthInsurance.data.result;
        _this3.healthInsuranceLoading = true;
      }).catch(function (err) {
        _this3.snackbarConfig.snackbar = true;
        _this3.snackbarConfig.color = 'warning';
        _this3.snackbarConfig.text = 'Erro ao carregar convênios, tente novamente!';
        console.log(err);
      });
    },
    formatDate: function formatDate(date) {
      if (!date) {
        return null;
      }

      var _date$split = date.split('-'),
          _date$split2 = slicedToArray_default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return month + '/' + day + '/' + year;
    },
    parseDate: function parseDate(date) {
      if (!date) {
        return null;
      }

      var _date$split3 = date.split('/'),
          _date$split4 = slicedToArray_default()(_date$split3, 3),
          month = _date$split4[0],
          day = _date$split4[1],
          year = _date$split4[2];

      return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
    },
    submit: function submit() {
      var _this4 = this;

      this.$validator.validateAll();
      var cpfValid = this.auth.cpf.replace('.', '').replace('-', '');
      if (!cpf_cnpj["CPF"].isValid(cpfValid)) {
        this.snackbarConfig.snackbar = true;
        this.snackbarConfig.text = 'CPF inválido!';
        return false;
      }
      var user = {
        name: this.auth.name,
        username: this.auth.username.trim(),
        password: this.auth.password.trim(),
        enabled: true,
        customer: this.customer,
        customerName: '',
        type: 'Owner',
        healthInsurance: this.auth.healthInsurance,
        cpf: this.auth.cpf,
        birthDay: this.auth.birthDay.substring(2, 4) + '-' + this.auth.birthDay.substring(0, 2) + '-' + this.auth.birthDay.substring(4, 8),
        phone: this.auth.phone,
        mobile: this.auth.mobile,
        gender: this.auth.gender
      };

      if (this.$refs.form.validate()) {
        axios_default.a.post("https://api.spitzer.io" + '/schedule-online/auth/patient/create', user).then(function (result) {
          _this4.$router.push('/');
        }).catch(function (err) {
          // if (err.response.data.message) {
          //   this.snackbarConfig.snackbar = true
          //   this.snackbarConfig.text = err.response.data.message
          //   return false
          // }
          if (err.response.data.errors) {
            if (err.response.data.errors.birthDay) {
              _this4.snackbarConfig.snackbar = true;
              _this4.snackbarConfig.text = err.response.data.errors.birthDay.msg;
              return false;
            } else if (err.response.data.errors.name) {
              _this4.snackbarConfig.snackbar = true;
              _this4.snackbarConfig.text = err.response.data.errors.name.msg;
              return false;
            } else if (err.response.data.errors.username) {
              _this4.snackbarConfig.snackbar = true;
              _this4.snackbarConfig.text = err.response.data.errors.username.msg;
              return false;
            } else if (err.response.data.errors.password) {
              _this4.snackbarConfig.snackbar = true;
              _this4.snackbarConfig.text = err.response.data.errors.password.msg;
              return false;
            } else if (err.response.data.errors.mobile) {
              _this4.snackbarConfig.snackbar = true;
              _this4.snackbarConfig.text = err.response.data.errors.mobile.msg;
              return false;
            } else {
              _this4.snackbarConfig.snackbar = true;
              _this4.snackbarConfig.text = err.response.data.errors;
            }
          }
          _this4.snackbarConfig.snackbar = true;
          _this4.snackbarConfig.text = err.response.data.result.error;
        });
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3936957d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/Register.vue
var Register_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register"},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":"","lg4":""}},[_c('v-card',{staticClass:"card-main"},[_c('v-card-media',{class:_vm.changeCssColor(),attrs:{"src":_vm.changeLogo(),"height":"200px","contain":""}}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"type":"info","value":_vm.bodyData,"dismissible":""}},[_c('div',{staticClass:"headline"},[_vm._v("Usuário já cadastrado")]),_vm._v(" "),_c('p',[_vm._v("Seu usuário já esta cadastrado na nossa base de dados")]),_vm._v(" "),_c('p',[_vm._v("A plataforma "),_c('a',{attrs:{"href":"http://www.spitzer.io"}},[_vm._v("Spitzer")]),_vm._v(" tem agendamento online em várias clinicas e hospitais")]),_vm._v(" "),_c('p',[_vm._v("Informe seu telefone e seu convênio")])]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-text-field',{staticClass:"username",attrs:{"label":"E-Mail/Usuário","counter":40,"rules":[function (v) { return !!v || 'E-mail obrigatório!!'; }],"required":"","prepend-icon":"email"},on:{"blur":function($event){return _vm.searchEmail()}},model:{value:(_vm.auth.username),callback:function ($$v) {_vm.$set(_vm.auth, "username", $$v)},expression:"auth.username"}}),_vm._v(" "),_c('v-text-field',{staticClass:"name",attrs:{"disabled":_vm.bodyData,"label":"Nome","rules":_vm.nameRules,"counter":40,"required":""},model:{value:(_vm.auth.name),callback:function ($$v) {_vm.$set(_vm.auth, "name", $$v)},expression:"auth.name"}}),_vm._v(" "),_c('v-radio-group',{staticClass:"gender",attrs:{"row":""},model:{value:(_vm.auth.gender),callback:function ($$v) {_vm.$set(_vm.auth, "gender", $$v)},expression:"auth.gender"}},[_c('v-radio',{attrs:{"label":"Masculino","value":"M","color":"blue"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Feminino","value":"F","color":"red"}})],1),_vm._v(" "),_c('v-text-field',{staticClass:"cpf",attrs:{"label":"CPF","rules":[function (v) { return !!v || 'CPf obrigatório!!'; }],"required":"","mask":"###.###.###-##","disabled":_vm.bodyData},model:{value:(_vm.auth.cpf),callback:function ($$v) {_vm.$set(_vm.auth, "cpf", $$v)},expression:"auth.cpf"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('date_format:dd-MM-yyyy'),expression:"'date_format:dd-MM-yyyy'"}],staticClass:"birthDay",attrs:{"label":"Data Nasc.","mask":"date","error-messages":_vm.errors.collect('name'),"data-vv-name":"birthday","rules":[function (v) { return !!v || 'Data de Nasc. obrigatória!!'; }],"required":"","disabled":_vm.bodyData},model:{value:(_vm.auth.birthDay),callback:function ($$v) {_vm.$set(_vm.auth, "birthDay", $$v)},expression:"auth.birthDay"}}),_vm._v(" "),_c('v-select',{ref:"healthInsurance",staticClass:"healthInsurance",attrs:{"item-text":"name","item-value":"id","label":"Convênio","items":_vm.healthInsurances,"rules":[function (v) { return !!v || 'Convênio obrigatório!!'; }],"required":"","autocomplete":""},model:{value:(_vm.auth.healthInsurance),callback:function ($$v) {_vm.$set(_vm.auth, "healthInsurance", $$v)},expression:"auth.healthInsurance"}}),_vm._v(" "),(this.customer === '5ac6894e806793790864e9db')?_c('div',[_c('v-text-field',{staticClass:"mobile",attrs:{"label":"Fone Fixo","mask":"(##) ####-#####","prepend-icon":"phone"},model:{value:(_vm.auth.phone),callback:function ($$v) {_vm.$set(_vm.auth, "phone", $$v)},expression:"auth.phone"}})],1):_vm._e(),_vm._v(" "),_c('v-text-field',{staticClass:"mobile",attrs:{"label":"Celular","mask":"(##)# ####-####","prepend-icon":"phone","rules":[function (v) { return !!v || 'Você deve informar um número de celular!'; }],"required":""},model:{value:(_vm.auth.mobile),callback:function ($$v) {_vm.$set(_vm.auth, "mobile", $$v)},expression:"auth.mobile"}}),_vm._v(" "),_c('v-text-field',{ref:"password",staticClass:"password",attrs:{"name":"input-10-1","label":"Entre com sua senha","hint":"Deve conter mais de 6 caracteres","min":"6","rules":_vm.passwordRules,"append-icon":_vm.p1 ? 'visibility_off' : 'visibility',"append-icon-cb":function () { return (_vm.p1 = !_vm.p1); },"type":_vm.p1 ? 'password' : 'text',"counter":"","color":"cyan darken","loading":""},model:{value:(_vm.auth.password),callback:function ($$v) {_vm.$set(_vm.auth, "password", $$v)},expression:"auth.password"}},[(_vm.custom)?_c('v-progress-linear',{attrs:{"slot":"progress","value":_vm.progress,"height":"8","color":_vm.color},slot:"progress"}):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},on:{"click":_vm.submit}},[_vm._v("\n                      Cadastrar\n                    ")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/patient/login"}},[_c('v-btn',{on:{"click":_vm.clear}},[_vm._v("Voltar")])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('div',[_vm._v("© 2017 - "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"http://www.spitzer.io"}},[_vm._v("Spitzer.io")]),_vm._v(" - Todos os direitos reservados")])])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarConfig.timeout,"color":_vm.snackbarConfig.color,"multi-line":_vm.snackbarConfig.mode === 'multi-line',"vertical":_vm.snackbarConfig.mode === 'vertical'},model:{value:(_vm.snackbarConfig.snackbar),callback:function ($$v) {_vm.$set(_vm.snackbarConfig, "snackbar", $$v)},expression:"snackbarConfig.snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarConfig.text)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbarConfig.snackbar = false}}},[_vm._v("Fechar")])],1)],1)}
var Register_staticRenderFns = []
var Register_esExports = { render: Register_render, staticRenderFns: Register_staticRenderFns }
/* harmony default export */ var auth_Register = (Register_esExports);
// CONCATENATED MODULE: ./src/views/auth/Register.vue
function Register_injectStyle (ssrContext) {
  __webpack_require__("AZBX")
}
var Register_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Register___vue_template_functional__ = false
/* styles */
var Register___vue_styles__ = Register_injectStyle
/* scopeId */
var Register___vue_scopeId__ = "data-v-3936957d"
/* moduleIdentifier (server only) */
var Register___vue_module_identifier__ = null
var Register_Component = Register_normalizeComponent(
  Register,
  auth_Register,
  Register___vue_template_functional__,
  Register___vue_styles__,
  Register___vue_scopeId__,
  Register___vue_module_identifier__
)

/* harmony default export */ var views_auth_Register = (Register_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/auth/Register.dev.vue



var Register_dev__this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import { setTimeout } from 'timers'

/* harmony default export */ var Register_dev = ({
  name: 'Register',
  computed: extends_default()({
    progress: function progress() {
      return Math.min(100, this.auth.password.length * 10);
    },
    color: function color() {
      return ['error', 'warning', 'success'][Math.floor(this.progress / 40)];
    }
  }, Object(vuex_esm["c" /* mapGetters */])({
    customer: 'customer'
  }), Object(vuex_esm["c" /* mapGetters */])('app', ['getTheme'])),
  data: function data() {
    return {
      dialogCancel: false,
      bodyData: false,
      birthday: {
        dateFormatted: null,
        menu: false
      },
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de comunicação com o servidor'
      },
      nameRules: [function (v) {
        return !!v || 'Nome obrigatório!';
      }, function (v) {
        return v.length <= 40 || 'Limite de 40 caracteres';
      }],
      passwordRules: [function (v) {
        return !!v || 'Senha obrigatória!';
      }, function (v) {
        return v.length <= 20 || 'Limite de 20 caracteres';
      }],
      exists: false,
      e1: 0,
      p1: true,
      custom: true,
      healthInsurances: [],
      valid: true,
      auth: {
        name: '',
        username: '',
        password: '',
        passwordConfirm: '',
        enabled: true,
        customer: Register_dev__this.customer,
        customerName: '',
        type: 'Owner',
        cpf: '',
        birthDay: '',
        healthInsurance: '',
        phone: '',
        mobile: '',
        gender: 'M'
      },
      checkbox: false
    };
  },
  mounted: function mounted() {
    // console.log(this.$validator)
    this.loadHealthInsurance();
    // console.log(this.auth.birthDay.substring(0, 2) + '-' + this.auth.birthDay.substring(2, 4) + '-' + this.auth.birthDay.substring(4, 8))
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setUser']), {
    changeCssColor: function changeCssColor() {
      var customerTheme = config_customersTheme[localStorage.getItem('riscSchedulePatientCustomer')];
      // console.log(customerTheme.cssClass)
      return customerTheme.cssClass;
    },
    changeLogo: function changeLogo() {
      var customerTheme = config_customersTheme[localStorage.getItem('riscSchedulePatientCustomer')];
      return customerTheme.logo;
    },
    searchEmail: function searchEmail() {
      var _this2 = this;

      console.log(this.customer);
      this.$http.get("https://api.spitzer.io" + '/schedule-online/auth/patient/search-user', {
        params: {
          customer: this.customer,
          username: this.auth.username
        }
      }).then(function (emailUser) {
        _this2.dialogCancel = true;
        /** Verifica se já existe cadastro neste cliente */
        // const customer = emailUser.data.result[0].scheduleOnline.client.map(item => item.customer)
        // const exists = customer.filter(item => item === this.customer)
        // console.log(exists)
        // if (exists) {
        //   this.snackbarConfig.snackbar = true
        //   this.snackbarConfig.color = 'info'
        //   this.snackbarConfig.text = 'Você já possui cadastro!'
        //   setTimeout(() => {
        //     this.$router.push('/patient/login')
        //   }, 3000)
        // }
        /** *************************************** */

        // this.snackbarConfig.snackbar = true
        // this.snackbarConfig.color = 'info'
        // this.snackbarConfig.text = 'Você já possui cadastro na nossa base de dados! Digite sua senha já cadastrada'

        _this2.bodyData = true;
        _this2.auth = {
          username: _this2.auth.username,
          name: emailUser.data.result[0].name,
          password: '',
          enabled: true,
          passwordConfirm: '',
          customer: _this2.customer,
          customerName: '',
          type: 'Owner',
          cpf: emailUser.data.result[0].profile.cpf,
          birthDay: moment_default()(emailUser.data.result[0].profile.birthDay, 'MM/DD/YYYY').format('DD/MM/YYYY'),
          healthInsurance: '',
          phone: emailUser.data.result[0].profile.phone,
          mobile: emailUser.data.result[0].profile.mobile,
          gender: emailUser.data.result[0].profile.gender
          // this.$refs.healthInsurance.focus()
        };
      }).catch(function (err) {
        console.log(err);
      });
    },
    loadHealthInsurance: function loadHealthInsurance() {
      var _this3 = this;

      this.$http.get("https://api.spitzer.io" + '/schedule-online/health-insurance', {
        params: {
          customer: this.customer
        }
      }).then(function (healthInsurance) {
        _this3.healthInsurances = healthInsurance.data.result;
        _this3.healthInsuranceLoading = true;
      }).catch(function (err) {
        _this3.snackbarConfig.snackbar = true;
        _this3.snackbarConfig.color = 'warning';
        _this3.snackbarConfig.text = 'Erro ao carregar convênios, tente novamente!';
        console.log(err);
      });
    },
    formatDate: function formatDate(date) {
      if (!date) {
        return null;
      }

      var _date$split = date.split('-'),
          _date$split2 = slicedToArray_default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return month + '/' + day + '/' + year;
    },
    parseDate: function parseDate(date) {
      if (!date) {
        return null;
      }

      var _date$split3 = date.split('/'),
          _date$split4 = slicedToArray_default()(_date$split3, 3),
          month = _date$split4[0],
          day = _date$split4[1],
          year = _date$split4[2];

      return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
    },
    submit: function submit() {
      var _this4 = this;

      console.log(this.auth.birthDay);
      this.$validator.validateAll();
      var cpfValid = this.auth.cpf.replace('.', '').replace('-', '');
      if (!cpf_cnpj["CPF"].isValid(cpfValid)) {
        this.snackbarConfig.snackbar = true;
        this.snackbarConfig.text = 'CPF inválido!';
        return false;
      }
      var user = {
        name: this.auth.name,
        username: this.auth.username.trim(),
        password: this.auth.password.trim(),
        enabled: true,
        customer: this.customer,
        customerName: '',
        type: 'Owner',
        healthInsurance: this.auth.healthInsurance,
        cpf: this.auth.cpf,
        birthDay: this.auth.birthDay.substring(2, 4) + '-' + this.auth.birthDay.substring(0, 2) + '-' + this.auth.birthDay.substring(4, 8),
        phone: this.auth.phone,
        mobile: this.auth.mobile,
        gender: this.auth.gender
      };

      if (this.$refs.form.validate()) {
        axios_default.a.post("https://api.spitzer.io" + '/schedule-online/auth/patient/create', user).then(function (result) {
          _this4.$router.push('/');
        }).catch(function (err) {
          // if (err.response.data.message) {
          //   this.snackbarConfig.snackbar = true
          //   this.snackbarConfig.text = err.response.data.message
          //   return false
          // }
          if (err.response.data.errors) {
            if (err.response.data.errors.birthDay) {
              _this4.snackbarConfig.snackbar = true;
              _this4.snackbarConfig.text = err.response.data.errors.birthDay.msg;
              return false;
            } else if (err.response.data.errors.name) {
              _this4.snackbarConfig.snackbar = true;
              _this4.snackbarConfig.text = err.response.data.errors.name.msg;
              return false;
            } else if (err.response.data.errors.username) {
              _this4.snackbarConfig.snackbar = true;
              _this4.snackbarConfig.text = err.response.data.errors.username.msg;
              return false;
            } else if (err.response.data.errors.password) {
              _this4.snackbarConfig.snackbar = true;
              _this4.snackbarConfig.text = err.response.data.errors.password.msg;
              return false;
            } else if (err.response.data.errors.mobile) {
              _this4.snackbarConfig.snackbar = true;
              _this4.snackbarConfig.text = err.response.data.errors.mobile.msg;
              return false;
            } else {
              _this4.snackbarConfig.snackbar = true;
              _this4.snackbarConfig.text = err.response.data.errors;
            }
          }
          _this4.snackbarConfig.snackbar = true;
          _this4.snackbarConfig.text = err.response.data.result.error;
        });
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3995e64","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/Register.dev.vue
var Register_dev_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register"},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":"","lg4":""}},[_c('v-card',{staticClass:"card-main"},[_c('v-card-media',{class:_vm.changeCssColor(),attrs:{"src":_vm.changeLogo(),"height":"200px","contain":""}}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"headline"},[_vm._v("Dev")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"info","value":_vm.bodyData,"dismissible":""}},[_c('div',{staticClass:"headline"},[_vm._v("Usuário já cadastrado")]),_vm._v(" "),_c('p',[_vm._v("Seu usuário já esta cadastrado na nossa base de dados")]),_vm._v(" "),_c('p',[_vm._v("A plataforma "),_c('a',{attrs:{"href":"http://www.spitzer.io"}},[_vm._v("Spitzer")]),_vm._v(" tem agendamento online em várias clinicas e hospitais")]),_vm._v(" "),_c('p',[_vm._v("Informe seu telefone e seu convênio")])]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-text-field',{staticClass:"username",attrs:{"label":"E-Mail/Usuário","counter":40,"rules":[function (v) { return !!v || 'E-mail obrigatório!!'; }],"required":"","prepend-icon":"email"},on:{"blur":function($event){return _vm.searchEmail()}},model:{value:(_vm.auth.username),callback:function ($$v) {_vm.$set(_vm.auth, "username", $$v)},expression:"auth.username"}}),_vm._v(" "),_c('v-text-field',{staticClass:"name",attrs:{"disabled":_vm.bodyData,"label":"Nome","rules":_vm.nameRules,"counter":40,"required":""},model:{value:(_vm.auth.name),callback:function ($$v) {_vm.$set(_vm.auth, "name", $$v)},expression:"auth.name"}}),_vm._v(" "),_c('v-radio-group',{staticClass:"gender",attrs:{"row":""},model:{value:(_vm.auth.gender),callback:function ($$v) {_vm.$set(_vm.auth, "gender", $$v)},expression:"auth.gender"}},[_c('v-radio',{attrs:{"label":"Masculino","value":"M","color":"blue"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Feminino","value":"F","color":"red"}})],1),_vm._v(" "),_c('v-text-field',{staticClass:"cpf",attrs:{"label":"CPF","rules":[function (v) { return !!v || 'CPf obrigatório!!'; }],"required":"","mask":"###.###.###-##","disabled":_vm.bodyData},model:{value:(_vm.auth.cpf),callback:function ($$v) {_vm.$set(_vm.auth, "cpf", $$v)},expression:"auth.cpf"}}),_vm._v(" "),_c('v-text-field',{staticClass:"birthDay",attrs:{"label":"Data Nasc.","mask":"date","rules":[function (v) { return !!v || 'Data de Nasc. obrigatória!!'; }],"required":"","disabled":_vm.bodyData},model:{value:(_vm.auth.birthDay),callback:function ($$v) {_vm.$set(_vm.auth, "birthDay", $$v)},expression:"auth.birthDay"}}),_vm._v(" "),_c('v-select',{ref:"healthInsurance",staticClass:"healthInsurance",attrs:{"item-text":"name","item-value":"id","label":"Convênio","items":_vm.healthInsurances,"rules":[function (v) { return !!v || 'Convênio obrigatório!!'; }],"required":""},model:{value:(_vm.auth.healthInsurance),callback:function ($$v) {_vm.$set(_vm.auth, "healthInsurance", $$v)},expression:"auth.healthInsurance"}}),_vm._v(" "),(this.customer === '5ac6894e806793790864e9db')?_c('div',[_c('v-text-field',{staticClass:"mobile",attrs:{"label":"Fone Fixo","mask":"(##) ####-#####","prepend-icon":"phone"},model:{value:(_vm.auth.phone),callback:function ($$v) {_vm.$set(_vm.auth, "phone", $$v)},expression:"auth.phone"}})],1):_vm._e(),_vm._v(" "),_c('v-text-field',{staticClass:"mobile",attrs:{"label":"Celular","mask":"(##)# ####-####","prepend-icon":"phone","rules":[function (v) { return !!v || 'Você deve informar um número de celular!'; }],"required":""},model:{value:(_vm.auth.mobile),callback:function ($$v) {_vm.$set(_vm.auth, "mobile", $$v)},expression:"auth.mobile"}}),_vm._v(" "),_c('v-text-field',{ref:"password",staticClass:"password",attrs:{"name":"input-10-1","label":"Entre com sua senha","hint":"Deve conter mais de 6 caracteres","min":"6","rules":_vm.passwordRules,"append-icon":_vm.p1 ? 'visibility_off' : 'visibility',"append-icon-cb":function () { return (_vm.p1 = !_vm.p1); },"type":_vm.p1 ? 'password' : 'text',"counter":"","color":"cyan darken","loading":""},model:{value:(_vm.auth.password),callback:function ($$v) {_vm.$set(_vm.auth, "password", $$v)},expression:"auth.password"}},[(_vm.custom)?_c('v-progress-linear',{attrs:{"slot":"progress","value":_vm.progress,"height":"8","color":_vm.color},slot:"progress"}):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},on:{"click":_vm.submit}},[_vm._v("\n                      Cadastrar\n                    ")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/patient/login"}},[_c('v-btn',{on:{"click":_vm.clear}},[_vm._v("Voltar")])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('div',[_vm._v("© 2017 - "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"http://www.spitzer.io"}},[_vm._v("Spitzer.io")]),_vm._v(" - Todos os direitos reservados")])])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarConfig.timeout,"color":_vm.snackbarConfig.color,"multi-line":_vm.snackbarConfig.mode === 'multi-line',"vertical":_vm.snackbarConfig.mode === 'vertical'},model:{value:(_vm.snackbarConfig.snackbar),callback:function ($$v) {_vm.$set(_vm.snackbarConfig, "snackbar", $$v)},expression:"snackbarConfig.snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarConfig.text)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbarConfig.snackbar = false}}},[_vm._v("Fechar")])],1)],1)}
var Register_dev_staticRenderFns = []
var Register_dev_esExports = { render: Register_dev_render, staticRenderFns: Register_dev_staticRenderFns }
/* harmony default export */ var auth_Register_dev = (Register_dev_esExports);
// CONCATENATED MODULE: ./src/views/auth/Register.dev.vue
function Register_dev_injectStyle (ssrContext) {
  __webpack_require__("RfsH")
}
var Register_dev_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Register_dev___vue_template_functional__ = false
/* styles */
var Register_dev___vue_styles__ = Register_dev_injectStyle
/* scopeId */
var Register_dev___vue_scopeId__ = "data-v-b3995e64"
/* moduleIdentifier (server only) */
var Register_dev___vue_module_identifier__ = null
var Register_dev_Component = Register_dev_normalizeComponent(
  Register_dev,
  auth_Register_dev,
  Register_dev___vue_template_functional__,
  Register_dev___vue_styles__,
  Register_dev___vue_scopeId__,
  Register_dev___vue_module_identifier__
)

/* harmony default export */ var views_auth_Register_dev = (Register_dev_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/auth/Reset-password.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import localforage from 'localforage'



/* harmony default export */ var Reset_password = ({
  name: 'Reset-password',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    customer: 'customer',
    tokenRecoveryPassword: 'tokenRecoveryPassword'
  }), Object(vuex_esm["c" /* mapGetters */])('app', ['getTheme', 'getPkg']), {
    progress: function progress() {
      return Math.min(100, this.authentication.password.length * 10);
    },
    color: function color() {
      return ['error', 'warning', 'success'][Math.floor(this.progress / 40)];
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.jwtDecoded();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  data: function data() {
    return {
      env: "https://api.spitzer.io",
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      valid: true,
      e1: true,
      p1: true,
      custom: true,
      authentication: {
        id: '',
        username: '',
        password: '',
        confpass: ''
      }
    };
  },
  methods: {
    jwtDecoded: function jwtDecoded() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var body, params;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                body = {
                  id: _this2.authentication.id
                };
                params = {
                  params: {
                    jwt: _this2.tokenRecoveryPassword,
                    customer: _this2.customer
                  }
                };
                _context2.next = 4;
                return axios_default.a.post("https://api.spitzer.io" + '/schedule-online/auth/patient/get-recovery-token', body, params).then(function (response) {
                  _this2.authentication.username = response.data.decoded.username;
                  _this2.authentication.id = response.data.decoded.id;
                }).catch(function (err) {
                  window.console.error(err);
                  _this2.snackbarConfig.snackbar = true;
                  _this2.snackbarConfig.text = 'Token expirado!';
                  return false;
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    changeCssColor: function changeCssColor() {
      var customerTheme = config_customersTheme[localStorage.getItem('riscSchedulePatientCustomer')];
      return customerTheme.cssClass;
    },
    changeLogo: function changeLogo() {
      var customerTheme = config_customersTheme[localStorage.getItem('riscSchedulePatientCustomer')];
      return customerTheme.logo;
    },
    changeColorHTML: function changeColorHTML() {
      var customerTheme = config_customersTheme[localStorage.getItem('riscSchedulePatientCustomer')];
      return customerTheme.colorHTML;
    },
    submit: function submit() {
      var _this3 = this;

      if (this.authentication.password !== this.authentication.confpass) {
        this.snackbarConfig.snackbar = true;
        this.snackbarConfig.text = 'As senhas são divergentes!';
        return false;
      }

      if (this.$refs.form.validate()) {
        axios_default.a.post("https://api.spitzer.io" + '/schedule-online/auth/patient/reset-password', {
          id: this.authentication.id,
          username: this.authentication.username,
          password: this.authentication.password
        }, {
          params: {
            customer: this.customer
          }
        }).then(function (response) {
          _this3.$router.push('/patient/login');
        }).catch(function (err) {
          if (err.response.data.message) {
            _this3.snackbarConfig.snackbar = true;
            _this3.snackbarConfig.text = err.response.data.message;
            return false;
          }
          if (err.response.data.errors) {
            if (err.response.data.errors.username) {
              _this3.snackbarConfig.snackbar = true;
              _this3.snackbarConfig.text = err.response.data.errors.username.msg;
              return false;
            }
            if (err.response.data.errors.password) {
              _this3.snackbarConfig.snackbar = true;
              _this3.snackbarConfig.text = err.response.data.errors.username.password.msg;
              return false;
            }
          }
          _this3.snackbarConfig.snackbar = true;
          _this3.snackbarConfig.text = err.response.data.result.error;
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59fda4b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/Reset-password.vue
var Reset_password_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":"","lg4":""}},[_c('v-card',[_c('v-card-media',{class:_vm.changeCssColor(),attrs:{"src":_vm.changeLogo(),"height":"200px","contain":""}}),_vm._v(" "),_c('div',{staticClass:"backgroud-logo logo"}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-card-text',[_c('p',{staticClass:"text-xs-center title primary--text"},[_vm._v("Redefinir senha")]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"action":"#","lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.submit()}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":"E-Mail","rules":[function (v) { return !!v || 'Você deve informar um número de telefone!'; }],"required":"","disabled":""},model:{value:(_vm.authentication.username),callback:function ($$v) {_vm.$set(_vm.authentication, "username", $$v)},expression:"authentication.username"}}),_vm._v(" "),_c('v-text-field',{ref:"password",staticClass:"password",attrs:{"name":"input-10-1","label":"Entre com sua senha","hint":"Deve conter mais de 6 caracteres","min":"6","rules":[function (v) { return !!v || 'Você deve informar a senha!'; }],"required":"","append-icon":_vm.p1 ? 'visibility_off' : 'visibility',"append-icon-cb":function () { return (_vm.p1 = !_vm.p1); },"type":_vm.p1 ? 'password' : 'text',"counter":"","color":"cyan darken","loading":""},model:{value:(_vm.authentication.password),callback:function ($$v) {_vm.$set(_vm.authentication, "password", $$v)},expression:"authentication.password"}},[(_vm.custom)?_c('v-progress-linear',{attrs:{"slot":"progress","value":_vm.progress,"height":"8","color":_vm.color},slot:"progress"}):_vm._e()],1),_vm._v(" "),_c('v-text-field',{staticClass:"password",attrs:{"type":"password","label":"Confirme sua senha","rules":[function (v) { return !!v || 'Você deve informar a senha!'; }],"required":""},model:{value:(_vm.authentication.confpass),callback:function ($$v) {_vm.$set(_vm.authentication, "confpass", $$v)},expression:"authentication.confpass"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","block":"","disabled":!_vm.valid},on:{"click":function($event){return _vm.submit()}}},[_vm._v("\n                Alterar senha\n              ")]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":"/patient/login"}},[_c('v-btn',{attrs:{"block":""}},[_vm._v("Login")])],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('div',[_c('p',[_vm._v("© 2017 - "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"http://www.spitzer.io"}},[_vm._v("Spitzer.io")]),_vm._v(" - Todos os direitos reservados")]),_vm._v(" "),_c('p',[_vm._v("Versão: "+_vm._s(_vm.getPkg.pkg.version))])])])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarConfig.timeout,"color":_vm.snackbarConfig.color,"multi-line":_vm.snackbarConfig.mode === 'multi-line',"vertical":_vm.snackbarConfig.mode === 'vertical'},model:{value:(_vm.snackbarConfig.snackbar),callback:function ($$v) {_vm.$set(_vm.snackbarConfig, "snackbar", $$v)},expression:"snackbarConfig.snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarConfig.text)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbarConfig.snackbar = false}}},[_vm._v("Fechar")])],1)],1)}
var Reset_password_staticRenderFns = []
var Reset_password_esExports = { render: Reset_password_render, staticRenderFns: Reset_password_staticRenderFns }
/* harmony default export */ var auth_Reset_password = (Reset_password_esExports);
// CONCATENATED MODULE: ./src/views/auth/Reset-password.vue
var Reset_password_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Reset_password___vue_template_functional__ = false
/* styles */
var Reset_password___vue_styles__ = null
/* scopeId */
var Reset_password___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Reset_password___vue_module_identifier__ = null
var Reset_password_Component = Reset_password_normalizeComponent(
  Reset_password,
  auth_Reset_password,
  Reset_password___vue_template_functional__,
  Reset_password___vue_styles__,
  Reset_password___vue_scopeId__,
  Reset_password___vue_module_identifier__
)

/* harmony default export */ var views_auth_Reset_password = (Reset_password_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/auth/Forget-password.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import localforage from 'localforage'



/* harmony default export */ var Forget_password = ({
  name: 'Reset-password',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    customer: 'customer'
  }), Object(vuex_esm["c" /* mapGetters */])('app', ['getTheme', 'getPkg']), {
    progress: function progress() {
      return Math.min(100, this.auth.password.length * 10);
    },
    color: function color() {
      return ['error', 'warning', 'success'][Math.floor(this.progress / 40)];
    }
  }),
  mounted: function mounted() {},

  data: function data() {
    return {
      env: "https://api.spitzer.io",
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      valid: true,
      e1: true,
      p1: true,
      custom: true,
      auth: {
        username: ''
      }
    };
  },
  methods: {
    changeCssColor: function changeCssColor() {
      var customerTheme = config_customersTheme[localStorage.getItem('riscSchedulePatientCustomer')];
      // console.log(customerTheme.cssClass)
      return customerTheme.cssClass;
    },
    changeLogo: function changeLogo() {
      var customerTheme = config_customersTheme[localStorage.getItem('riscSchedulePatientCustomer')];
      return customerTheme.logo;
    },
    changeColorHTML: function changeColorHTML() {
      var customerTheme = config_customersTheme[localStorage.getItem('riscSchedulePatientCustomer')];
      return customerTheme.colorHTML;
    },
    submit: function submit() {
      var _this = this;

      if (this.$refs.form.validate()) {
        axios_default.a.post("https://api.spitzer.io" + '/schedule-online/auth/patient/forget-password', {
          username: this.auth.username.toLowerCase()
        }, {
          params: {
            customer: this.customer
          }
        }).then(function (response) {
          _this.$router.push('/');
        }).catch(function (err) {
          window.console.log(err.response);
          if (err.response.data.message) {
            _this.snackbarConfig.snackbar = true;
            _this.snackbarConfig.text = err.response.data.message;
            return false;
          }
          if (err.response.data.errors) {
            if (err.response.data.errors.username) {
              window.console.log(err.response.data.errors.username.msg);
              _this.snackbarConfig.text = err.response.data.errors.username.msg;
              _this.snackbarConfig.snackbar = true;
              return false;
            }
          }
          _this.snackbarConfig.snackbar = true;
          _this.snackbarConfig.text = err.response.data.result.error;
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d68ce00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/Forget-password.vue
var Forget_password_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":"","lg4":""}},[_c('v-card',[_c('v-card-media',{class:_vm.changeCssColor(),attrs:{"src":_vm.changeLogo(),"height":"200px","contain":""}}),_vm._v(" "),_c('div',{staticClass:"backgroud-logo logo"}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-card-text',[_c('p',{staticClass:"text-xs-center title primary--text"},[_vm._v("Recuperação de senha")]),_vm._v(" "),_c('p',{staticClass:"text-xs-center title primary--text"},[_vm._v("\n              Para recuperar sua senha de acesso, informe no campo abaixo o email utilizado no cadastro.\n            ")]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"action":"#","lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.submit()}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":"E-Mail","rules":[function (v) { return !!v || 'Informe o e-mail cadastrado!'; }],"required":""},model:{value:(_vm.auth.username),callback:function ($$v) {_vm.$set(_vm.auth, "username", $$v)},expression:"auth.username"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","block":"","disabled":!_vm.valid},on:{"click":function($event){return _vm.submit()}}},[_vm._v("\n                Recuperar Senha\n              ")]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":"/patient/login"}},[_c('v-btn',{attrs:{"block":""}},[_vm._v("Retornar para Login")])],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('div',[_c('p',[_vm._v("© 2017 - "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"http://www.spitzer.io"}},[_vm._v("Spitzer.io")]),_vm._v(" - Todos os direitos reservados")]),_vm._v(" "),_c('p',[_vm._v("Versão: "+_vm._s(_vm.getPkg.pkg.version))])])])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarConfig.timeout,"color":_vm.snackbarConfig.color,"multi-line":_vm.snackbarConfig.mode === 'multi-line',"vertical":_vm.snackbarConfig.mode === 'vertical'},model:{value:(_vm.snackbarConfig.snackbar),callback:function ($$v) {_vm.$set(_vm.snackbarConfig, "snackbar", $$v)},expression:"snackbarConfig.snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarConfig.text)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbarConfig.snackbar = false}}},[_vm._v("Fechar")])],1)],1)}
var Forget_password_staticRenderFns = []
var Forget_password_esExports = { render: Forget_password_render, staticRenderFns: Forget_password_staticRenderFns }
/* harmony default export */ var auth_Forget_password = (Forget_password_esExports);
// CONCATENATED MODULE: ./src/views/auth/Forget-password.vue
var Forget_password_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Forget_password___vue_template_functional__ = false
/* styles */
var Forget_password___vue_styles__ = null
/* scopeId */
var Forget_password___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Forget_password___vue_module_identifier__ = null
var Forget_password_Component = Forget_password_normalizeComponent(
  Forget_password,
  auth_Forget_password,
  Forget_password___vue_template_functional__,
  Forget_password___vue_styles__,
  Forget_password___vue_scopeId__,
  Forget_password___vue_module_identifier__
)

/* harmony default export */ var views_auth_Forget_password = (Forget_password_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/profile/Reset-password.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import localforage from 'localforage'



/* harmony default export */ var profile_Reset_password = ({
  name: 'Reset-password',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    customer: 'customer',
    tokenRecoveryPassword: 'tokenRecoveryPassword',
    auth: 'auth'
  }), Object(vuex_esm["c" /* mapGetters */])('app', ['getTheme', 'getPkg']), {
    progress: function progress() {
      return Math.min(100, this.authentication.password.length * 10);
    },
    color: function color() {
      return ['error', 'warning', 'success'][Math.floor(this.progress / 40)];
    }
  }),
  mounted: function mounted() {
    this.authentication.id = this.auth.user.id;
    this.authentication.username = this.auth.user.username;
  },

  data: function data() {
    return {
      env: "https://api.spitzer.io",
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      valid: true,
      e1: true,
      p1: true,
      custom: true,
      authentication: {
        id: '',
        username: '',
        password: '',
        confpass: ''
      }
    };
  },
  methods: {
    changeCssColor: function changeCssColor() {
      var customerTheme = config_customersTheme[localStorage.getItem('riscSchedulePatientCustomer')];
      return customerTheme.cssClass;
    },
    changeLogo: function changeLogo() {
      var customerTheme = config_customersTheme[localStorage.getItem('riscSchedulePatientCustomer')];
      return customerTheme.logo;
    },
    changeColorHTML: function changeColorHTML() {
      var customerTheme = config_customersTheme[localStorage.getItem('riscSchedulePatientCustomer')];
      return customerTheme.colorHTML;
    },
    submit: function submit() {
      var _this = this;

      if (this.authentication.password !== this.authentication.confpass) {
        this.snackbarConfig.snackbar = true;
        this.snackbarConfig.text = 'As senhas são divergentes!';
        return false;
      }

      if (this.$refs.form.validate()) {
        axios_default.a.post("https://api.spitzer.io" + '/schedule-online/auth/patient/reset-password', {
          id: this.authentication.id,
          username: this.authentication.username,
          password: this.authentication.password
        }, {
          params: {
            customer: this.customer
          }
        }).then(function (response) {
          console.log(response.data);
          _this.snackbarConfig.snackbar = true;
          _this.snackbarConfig.text = 'Senha atualizada com sucesso!';
          return true;
          // this.$router.push('/')
        }).catch(function (err) {
          if (err.response.data.message) {
            _this.snackbarConfig.snackbar = true;
            _this.snackbarConfig.text = err.response.data.message;
            return false;
          }
          if (err.response.data.errors) {
            if (err.response.data.errors.username) {
              _this.snackbarConfig.snackbar = true;
              _this.snackbarConfig.text = err.response.data.errors.username.msg;
              return false;
            }
            if (err.response.data.errors.password) {
              _this.snackbarConfig.snackbar = true;
              _this.snackbarConfig.text = err.response.data.errors.username.password.msg;
              return false;
            }
          }
          _this.snackbarConfig.snackbar = true;
          _this.snackbarConfig.text = err.response.data.result.error;
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afc1995a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/profile/Reset-password.vue
var profile_Reset_password_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":"","lg4":""}},[_c('v-card',[_c('div',{staticClass:"backgroud-logo logo"}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-card-text',[_c('p',{staticClass:"text-xs-center title primary--text"},[_vm._v("Redefinir senha")]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"action":"#","lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.submit()}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":"E-Mail","rules":[function (v) { return !!v || 'Você deve informar um e-mail!'; }],"required":"","disabled":""},model:{value:(_vm.authentication.username),callback:function ($$v) {_vm.$set(_vm.authentication, "username", $$v)},expression:"authentication.username"}}),_vm._v(" "),_c('v-text-field',{ref:"password",staticClass:"password",attrs:{"name":"input-10-1","label":"Entre com sua nova senha","hint":"Deve conter mais de 6 caracteres","min":"6","rules":[function (v) { return !!v || 'Você deve informar a sua senha!'; }],"required":"","append-icon":_vm.p1 ? 'visibility_off' : 'visibility',"append-icon-cb":function () { return (_vm.p1 = !_vm.p1); },"type":_vm.p1 ? 'password' : 'text',"counter":"","color":"cyan darken","loading":""},model:{value:(_vm.authentication.password),callback:function ($$v) {_vm.$set(_vm.authentication, "password", $$v)},expression:"authentication.password"}},[(_vm.custom)?_c('v-progress-linear',{attrs:{"slot":"progress","value":_vm.progress,"height":"8","color":_vm.color},slot:"progress"}):_vm._e()],1),_vm._v(" "),_c('v-text-field',{staticClass:"password",attrs:{"type":"password","label":"Confirme sua nova senha","rules":[function (v) { return !!v || 'Você deve informar a senha!'; }],"required":""},model:{value:(_vm.authentication.confpass),callback:function ($$v) {_vm.$set(_vm.authentication, "confpass", $$v)},expression:"authentication.confpass"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","block":"","disabled":!_vm.valid},on:{"click":function($event){return _vm.submit()}}},[_vm._v("\n                Alterar senha\n              ")]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_c('v-btn',{attrs:{"block":""}},[_vm._v("Cancelar")])],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('div',[_c('p',[_vm._v("© 2017 - "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"http://www.spitzer.io"}},[_vm._v("Spitzer.io")]),_vm._v(" - Todos os direitos reservados")]),_vm._v(" "),_c('p',[_vm._v("Versão: "+_vm._s(_vm.getPkg.pkg.version))])])])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarConfig.timeout,"color":_vm.snackbarConfig.color,"multi-line":_vm.snackbarConfig.mode === 'multi-line',"vertical":_vm.snackbarConfig.mode === 'vertical'},model:{value:(_vm.snackbarConfig.snackbar),callback:function ($$v) {_vm.$set(_vm.snackbarConfig, "snackbar", $$v)},expression:"snackbarConfig.snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarConfig.text)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbarConfig.snackbar = false}}},[_vm._v("Fechar")])],1),_vm._v(" -->\n")],1)}
var profile_Reset_password_staticRenderFns = []
var profile_Reset_password_esExports = { render: profile_Reset_password_render, staticRenderFns: profile_Reset_password_staticRenderFns }
/* harmony default export */ var views_profile_Reset_password = (profile_Reset_password_esExports);
// CONCATENATED MODULE: ./src/views/profile/Reset-password.vue
var profile_Reset_password_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var profile_Reset_password___vue_template_functional__ = false
/* styles */
var profile_Reset_password___vue_styles__ = null
/* scopeId */
var profile_Reset_password___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var profile_Reset_password___vue_module_identifier__ = null
var profile_Reset_password_Component = profile_Reset_password_normalizeComponent(
  profile_Reset_password,
  views_profile_Reset_password,
  profile_Reset_password___vue_template_functional__,
  profile_Reset_password___vue_styles__,
  profile_Reset_password___vue_scopeId__,
  profile_Reset_password___vue_module_identifier__
)

/* harmony default export */ var src_views_profile_Reset_password = (profile_Reset_password_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/profile/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var profile = ({
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setUser']), {
    submit: function submit() {
      var _this = this;

      this.$validator.validateAll();
      this.user.birthDay = moment_default()(this.auth.user.profile.birthDay).format('MM-DD-YYYY');
      this.$http.post("https://api.spitzer.io" + '/schedule-online/auth/patient/update', this.user, {
        params: {
          customer: this.customer
        }
      }).then(function (response) {
        var aaa = response.data.result.user;
        console.log(aaa);
        var auth = {
          isLogged: true,
          token: response.data.result.token,
          user: {
            username: _this.auth.user.username,
            id: response.data.result.result[0]._id,
            customer: _this.customer,
            name: response.data.result.result[0].name,
            healthInsurance: _this.user.healthInsurance,
            numberMedicalRecord: response.data.result.user.numberMedicalRecord,
            profile: response.data.result.result[0].profile
          }
        };
        _this.setUser(auth);
        _this.snackbarConfig.snackbar = true;
        _this.snackbarConfig.text = 'Dados atualizados!';
      });
    },
    loadHealthInsurance: function loadHealthInsurance() {
      var _this2 = this;

      this.$http.get("https://api.spitzer.io" + '/schedule-online/health-insurance', {
        params: {
          customer: this.customer
        }
      }).then(function (healthInsurance) {
        console.log(_this2.auth.user.healthInsurance);
        _this2.healthInsurances = healthInsurance.data.result;
        _this2.user.healthInsurance = _this2.auth.user.healthInsurance;
      }).catch(function (err) {
        console.log(err);
      });
    }
  }),
  mounted: function mounted() {
    this.loadHealthInsurance();
    this.user.id = this.auth.user.id;
    this.user.name = this.auth.user.name;
    this.user.numberMedicalRecord = this.auth.user.numberMedicalRecord;
    this.user.username = this.auth.user.username;
    this.user.birthDay = moment_default()(this.auth.user.profile.birthDay, 'MM/DD/YYYY').format('DD/MM/YYYY');
    this.user.cpf = this.auth.user.profile.cpf;
    this.user.healthInsurance = this.auth.user.healthInsurance;
    this.user.phone = this.auth.user.profile.phone;
    this.user.mobile = this.auth.user.profile.mobile;
    this.user.clientId = this.auth.user.clientId;
    this.user.gender = this.auth.user.profile.gender;
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    customer: 'customer',
    auth: 'auth'
  }), Object(vuex_esm["c" /* mapGetters */])('app', ['getTheme'])),
  data: function data() {
    return {
      snackbarConfig: {
        snackbar: false,
        color: 'info',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      healthInsurances: [],
      healthInsurance: '',
      valid: true,
      active: null,
      user: {
        id: '',
        name: '',
        username: '',
        password: '',
        passwordConfirm: '',
        enabled: true,
        customer: this.customer,
        customerName: '',
        type: 'Owner',
        cpf: '',
        birthDay: '',
        healthInsurance: '',
        phone: '',
        mobile: '',
        gender: 'M',
        numberMedicalRecord: '',
        clientId: ''
      }
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08a0921d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/profile/index.vue
var profile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Perfil")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":"","lg4":""}},[_c('v-card',{staticClass:"card-main"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-text-field',{staticClass:"username",attrs:{"label":"E-Mail/Usuário","counter":40,"rules":[function (v) { return !!v || 'E-mail obrigatório!!'; }],"required":"","prepend-icon":"email","disabled":""},model:{value:(_vm.user.username),callback:function ($$v) {_vm.$set(_vm.user, "username", $$v)},expression:"user.username"}}),_vm._v(" "),_c('v-text-field',{staticClass:"name",attrs:{"disabled":"","label":"Nome","counter":40,"required":""},model:{value:(_vm.user.name),callback:function ($$v) {_vm.$set(_vm.user, "name", $$v)},expression:"user.name"}}),_vm._v(" "),_c('v-text-field',{staticClass:"name",attrs:{"disabled":"","label":"Ficha","required":""},model:{value:(_vm.user.numberMedicalRecord),callback:function ($$v) {_vm.$set(_vm.user, "numberMedicalRecord", $$v)},expression:"user.numberMedicalRecord"}}),_vm._v(" "),_c('v-radio-group',{staticClass:"gender",attrs:{"row":"","disabled":""},model:{value:(_vm.user.gender),callback:function ($$v) {_vm.$set(_vm.user, "gender", $$v)},expression:"user.gender"}},[_c('v-radio',{attrs:{"label":"Masculino","value":"M","color":"blue","disabled":""}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Feminino","value":"F","color":"red","disabled":""}})],1),_vm._v(" "),_c('v-text-field',{staticClass:"cpf",attrs:{"disabled":"","label":"CPF","rules":[function (v) { return !!v || 'CPf obrigatório!!'; }],"required":"","mask":"###.###.###-##"},model:{value:(_vm.user.cpf),callback:function ($$v) {_vm.$set(_vm.user, "cpf", $$v)},expression:"user.cpf"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('date_format:DD-MM-YYYY'),expression:"'date_format:DD-MM-YYYY'"}],staticClass:"birthDay",attrs:{"disabled":"","label":"Data Nasc.","mask":"date","error-messages":_vm.errors.collect('name'),"data-vv-name":"birthday","rules":[function (v) { return !!v || 'Data de Nasc. obrigatória!!'; }],"required":""},model:{value:(_vm.user.birthDay),callback:function ($$v) {_vm.$set(_vm.user, "birthDay", $$v)},expression:"user.birthDay"}}),_vm._v(" "),_c('v-select',{ref:"healthInsurance",staticClass:"healthInsurance",attrs:{"item-text":"name","item-value":"id","label":"Convênio","items":_vm.healthInsurances,"rules":[function (v) { return !!v || 'Convênio obrigatório!!'; }],"required":""},model:{value:(_vm.user.healthInsurance),callback:function ($$v) {_vm.$set(_vm.user, "healthInsurance", $$v)},expression:"user.healthInsurance"}}),_vm._v(" "),_c('v-text-field',{staticClass:"mobile",attrs:{"label":"Fone Fixo","mask":"(##) ####-#####","prepend-icon":"phone"},model:{value:(_vm.user.phone),callback:function ($$v) {_vm.$set(_vm.user, "phone", $$v)},expression:"user.phone"}}),_vm._v(" "),_c('v-text-field',{staticClass:"mobile",attrs:{"label":"Celular","mask":"(##)# ####-####","prepend-icon":"phone","rules":[function (v) { return !!v || 'Você deve informar um número de celular!'; }],"required":""},model:{value:(_vm.user.mobile),callback:function ($$v) {_vm.$set(_vm.user, "mobile", $$v)},expression:"user.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},on:{"click":_vm.submit}},[_vm._v("\n                      Atualizar\n                    ")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_c('v-btn',[_vm._v("Voltar")])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('div',[_vm._v("© 2017 - "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"http://www.spitzer.io"}},[_vm._v("Spitzer.io")]),_vm._v(" - Todos os direitos reservados")])])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarConfig.timeout,"color":_vm.snackbarConfig.color,"multi-line":_vm.snackbarConfig.mode === 'multi-line',"vertical":_vm.snackbarConfig.mode === 'vertical'},model:{value:(_vm.snackbarConfig.snackbar),callback:function ($$v) {_vm.$set(_vm.snackbarConfig, "snackbar", $$v)},expression:"snackbarConfig.snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarConfig.text)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbarConfig.snackbar = false}}},[_vm._v("Fechar")])],1)],1)}
var profile_staticRenderFns = []
var profile_esExports = { render: profile_render, staticRenderFns: profile_staticRenderFns }
/* harmony default export */ var views_profile = (profile_esExports);
// CONCATENATED MODULE: ./src/views/profile/index.vue
var profile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var profile___vue_template_functional__ = false
/* styles */
var profile___vue_styles__ = null
/* scopeId */
var profile___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var profile___vue_module_identifier__ = null
var profile_Component = profile_normalizeComponent(
  profile,
  views_profile,
  profile___vue_template_functional__,
  profile___vue_styles__,
  profile___vue_scopeId__,
  profile___vue_module_identifier__
)

/* harmony default export */ var src_views_profile = (profile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/history-schedule-online/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import moment from 'moment'
// import { url } from '../../../config/api.link.connection'

/* harmony default export */ var history_schedule_online = ({
  mounted: function mounted() {
    this.loadingData();
  },

  methods: {
    data: function data(item) {
      this.item = item;
    },
    cancelAppointment: function cancelAppointment() {
      var _this = this;

      console.log(this.item);
      var item = this.item;
      this.$http.post("https://api.spitzer.io" + '/schedule-online/schedule-sync/cancel-appointment', {
        item: item
      }, {
        params: {
          customer: this.customer,
          username: this.auth.user.username
        }
      }).then(function (response) {
        _this.dialogCancel = false;
        _this.loadingData();
        console.log(response);
      }).catch(function (err) {
        console.log(err);
      });
    },
    loadingData: function loadingData() {
      var _this2 = this;

      this.$http.get("https://api.spitzer.io" + '/schedule-online/schedule-sync/scheduled-appointment', {
        params: {
          customer: this.customer,
          idUser: this.auth.user.id
        }
      }).then(function (result) {
        _this2.items = result.data.results.map(function (item) {
          item.hour = item.hour.substr(0, 5);
          return item;
        });
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    customer: 'customer',
    auth: 'auth'
  }), Object(vuex_esm["c" /* mapGetters */])('app', ['getTheme'])),
  data: function data() {
    return {
      dialogCancel: false,
      items: [],
      item: null
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70ffb9b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/history-schedule-online/index.vue
var history_schedule_online_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","lg4":""}},[(this.items.length)?_c('v-card',[_c('v-toolbar',{attrs:{"color":this.getTheme.color,"dark":""}},[_c('v-toolbar-side-icon'),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Meus agendamentos")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.items),function(item){return [(item.header)?_c('v-subheader',{key:item.header,domProps:{"textContent":_vm._s(item.header)}}):(item.divider)?_c('v-divider',{key:item.id,attrs:{"inset":item.inset}}):_c('v-list-tile',{key:item.title,attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("event")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.doctor)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(item.date)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(item.hour)}})],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":"","ripple":""},on:{"click":[function($event){$event.stopPropagation();_vm.dialogCancel = true},function($event){$event.preventDefault();return _vm.data(item)}]}},[_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("block")])],1)],1)],1)]})],2)],1):_c('div',[_c('p',[_vm._v("Você não possui agendamentos!")])])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialogCancel),callback:function ($$v) {_vm.dialogCancel=$$v},expression:"dialogCancel"}},[_c('v-card',[_c('v-card-title',[_vm._v("\n        Cancelamento de consulta\n      ")]),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"display-1"},[_vm._v("Deseja Cancelar sua consulta")])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){$event.preventDefault();return _vm.cancelAppointment()}}},[_vm._v("Cancelar a consulta")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogCancel=false}}},[_vm._v("Fechar")])],1)],1)],1)],1)}
var history_schedule_online_staticRenderFns = []
var history_schedule_online_esExports = { render: history_schedule_online_render, staticRenderFns: history_schedule_online_staticRenderFns }
/* harmony default export */ var views_history_schedule_online = (history_schedule_online_esExports);
// CONCATENATED MODULE: ./src/views/history-schedule-online/index.vue
var history_schedule_online_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var history_schedule_online___vue_template_functional__ = false
/* styles */
var history_schedule_online___vue_styles__ = null
/* scopeId */
var history_schedule_online___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var history_schedule_online___vue_module_identifier__ = null
var history_schedule_online_Component = history_schedule_online_normalizeComponent(
  history_schedule_online,
  views_history_schedule_online,
  history_schedule_online___vue_template_functional__,
  history_schedule_online___vue_styles__,
  history_schedule_online___vue_scopeId__,
  history_schedule_online___vue_module_identifier__
)

/* harmony default export */ var src_views_history_schedule_online = (history_schedule_online_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b6c6527","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/page404.vue
var page404_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var page404_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"logo"},[_c('p',[_vm._v("OOPS! - Volte para a pagina da Hospital/Clinica e tente novamente!")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("Adpk")}}),_vm._v(" "),_c('div',{staticClass:"sub"})])])}]
var page404_esExports = { render: page404_render, staticRenderFns: page404_staticRenderFns }
/* harmony default export */ var page404 = (page404_esExports);
// CONCATENATED MODULE: ./src/views/page404.vue
function page404_injectStyle (ssrContext) {
  __webpack_require__("1UXZ")
}
var page404_normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var page404___vue_template_functional__ = false
/* styles */
var page404___vue_styles__ = page404_injectStyle
/* scopeId */
var page404___vue_scopeId__ = "data-v-4b6c6527"
/* moduleIdentifier (server only) */
var page404___vue_module_identifier__ = null
var page404_Component = page404_normalizeComponent(
  __vue_script__,
  page404,
  page404___vue_template_functional__,
  page404___vue_styles__,
  page404___vue_scopeId__,
  page404___vue_module_identifier__
)

/* harmony default export */ var views_page404 = (page404_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js






















vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
var env = "production";
console.log(env);
var router = new vue_router_esm["a" /* default */]({
  mode: 'history', // Demo is living in GitHub.io, so required! hash
  history: true,
  linkActiveClass: 'is-active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/',
    name: 'home',
    component: views_schedule_Schedule,
    meta: { auth: true }
  }, {
    path: '/customer',
    name: 'customer',
    component: views_customer_Customer,
    meta: { auth: false }
  }, {
    path: '/patient/login',
    name: 'patientLogin',
    component: views_auth_Login,
    meta: { auth: false }
  }, {
    path: '/patient/reset-password',
    name: 'ResetPassword',
    component: views_auth_Reset_password,
    meta: { auth: false }
  }, {
    path: '/patient/recovery-password',
    name: 'ProfileResetPassword',
    component: src_views_profile_Reset_password,
    meta: { auth: true }
  }, {
    path: '/patient/forget-password',
    name: 'ForgetPassword',
    component: views_auth_Forget_password,
    meta: { auth: false }
  }, {
    path: '/patient/history',
    name: 'HistoryScheduleOnline',
    component: src_views_history_schedule_online,
    meta: { auth: true }
  }, {
    path: '/patient/register',
    name: 'patientRegister',
    component: env === 'development' ? views_auth_Register_dev : views_auth_Register,
    meta: { auth: false }
  }, {
    path: '/patient/profile',
    name: 'patientProfile',
    component: src_views_profile,
    meta: { auth: true }
  }, {
    path: '/pagenotfound',
    name: 'PageNotFound',
    component: views_page404,
    meta: {
      auth: false
    }
  }, {
    path: '*',
    redirect: '/patient/login'
  }]
});

var storageKey = 'riscSchedulePatientCustomer';

var router_setCustomerTheme = function setCustomerTheme(value) {
  var customerTheme = config_customersTheme[value];
  return src_store.dispatch('app/setTheme', {
    color: customerTheme.theme,
    colorHTML: customerTheme.colorHTML
  }).then(function () {
    if (false) {
      console.log('setTheme', customerTheme);
    }
  });
};

var router_setCustomer = function setCustomer(value) {
  return src_store.dispatch('setCustomer', value).then(function () {
    return localStorage.setItem(storageKey, value);
  });
};

/* Protege a rota */
router.beforeEach(function (to, from, next) {
  if (to.path === '/patient/reset-password' && to.query.token !== undefined) {
    // console.log(to.path)
    // console.log(to.query.token)
    src_store.dispatch('setTokenRecoveryPassword', to.query.token).then(function () {
      return console.log('aaa');
    });
  }

  if (src_store.state.auth.token) {
    // console.log('aqui é o token', store.state.auth.token)
    window.axios.defaults.headers.common['x-access-token'] = src_store.state.auth.token;
    window.axios.defaults.headers.common['Authorization'] = 'bearer ' + src_store.state.auth.token;
  }

  var customer = to.query.customer || localStorage.getItem(storageKey);

  localforage_default.a.getItem('token').then(function (value) {
    // console.log('rota', value)
  });
  localforage_default.a.getItem('user').then(function (value) {
    // console.log('rota', value)
  });

  var promise = new promise_default.a(function (resolve, reject) {
    if (to.path !== '/pagenotfound') {
      if (customer in config_customersTheme) {
        router_setCustomer(customer).then(function () {
          return router_setCustomerTheme(customer);
        }).then(function () {
          if (false) {
            console.log('cliente e tema resolvido');
          }
          resolve();
        });
      } else {
        console.log('pagenotfound');
        reject(new Error('Customer not found'));
      }
    } else {
      resolve();
    }
  });

  promise.then(function () {
    if (to.meta.auth === false) {
      return next();
    }

    if (to.meta.auth !== undefined || to.meta.auth !== false || to.meta.auth !== undefined) {
      if (!src_store.state.auth.isLogged && to.path !== '/patient/login') {
        return next('/patient/login');
      }
      return next();
    }
    return next();
  }).catch(function () {
    return next('/pagenotfound');
  });
});

/* harmony default export */ var src_router = (router);
// EXTERNAL MODULE: ./node_modules/vue-axios/dist/vue-axios.esm.min.js
var vue_axios_esm_min = __webpack_require__("aLYK");

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.js
var vuetify = __webpack_require__("3EgV");
var vuetify_default = /*#__PURE__*/__webpack_require__.n(vuetify);

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.css
var dist_vuetify = __webpack_require__("QCv7");
var dist_vuetify_default = /*#__PURE__*/__webpack_require__.n(dist_vuetify);

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.esm.js
var vee_validate_esm = __webpack_require__("sUu7");

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







// import firebase from './pluguins/firebase'






var config = {
  errorBagName: 'errors', // change if property conflicts
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true,
  classes: false,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true,
  validity: false,
  aria: true,
  i18n: null, // the vue-i18n plugin instance,
  i18nRootKey: 'validations' // the nested key under which the validation messsages will be located
};

vue_esm["a" /* default */].use(vee_validate_esm["a" /* default */], config);

vue_esm["a" /* default */].use(vuetify_default.a, {
  theme: {
    primary: '#3f51b5',
    secondary: '#b0bec5',
    accent: '#8c9eff',
    error: '#b71c1c'
  }
});

// Vue.use(firebase)

// const configAxios = axios.create({
//   baseURL: 'https://some-domain.com/api/',
//   timeout: 1000,
//   headers: { 'X-Custom-Header': 'foobar' }
// })
window.axios = axios_default.a;
axios_default.a.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// axios.defaults.headers.common['Authorization'] = 'Bearer ' + '23132123123123'
// axios.defaults.headers.common['x-access-token'] = '23132123123123'

vue_esm["a" /* default */].use(vue_axios_esm_min["a" /* default */], axios_default.a);

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: src_router,
  store: src_store,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "OISo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QCv7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RfsH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZEli":
/***/ (function(module, exports) {

// import * as types from '../../mutation-types'

// const state = {
//   items: [
//     {
//       name: 'Horarios',
//       path: '/',
//       meta: {
//         icon: 'fa-calendar',
//         link: 'Home.vue'
//       },
//       component: lazyLoading('home', true)
//     }
//   ]
// }

// const mutations = {
//   [types.EXPAND_MENU] (state, menuItem) {
//     if (menuItem.index > -1) {
//       if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
//         state.items[menuItem.index].meta.expanded = menuItem.expanded
//       }
//     } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
//       menuItem.item.meta.expanded = menuItem.expanded
//     }
//   }
// }

// export default {
//   state,
//   mutations
// }

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.a4d9c8f6f6c80b817ab3.js